/* eslint-disable */
// tslint:disable
/**
 * MTS Payments API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url'
import { Configuration } from './configuration'
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base'

/**
 *
 * @export
 * @interface AccountOperation
 */
export interface AccountOperation {
  /**
   * Дата проведения операции
   * @type {string}
   * @memberof AccountOperation
   */
  operationDate?: string
  /**
   *
   * @type {AccountOperationAmount}
   * @memberof AccountOperation
   */
  amount?: AccountOperationAmount
  /**
   *
   * @type {AccountOperationDetails}
   * @memberof AccountOperation
   */
  details?: AccountOperationDetails
}
/**
 *
 * @export
 * @interface AccountOperationAmount
 */
export interface AccountOperationAmount {
  /**
   * Сумма операции в валюте транзакции
   * @type {number}
   * @memberof AccountOperationAmount
   */
  amount?: number
  /**
   *
   * @type {Currency}
   * @memberof AccountOperationAmount
   */
  cur?: Currency
}
/**
 *
 * @export
 * @interface AccountOperationDetails
 */
export interface AccountOperationDetails {
  /**
   * Номер документа
   * @type {string}
   * @memberof AccountOperationDetails
   */
  docId?: string
  /**
   * Категория операции
   * @type {string}
   * @memberof AccountOperationDetails
   */
  category?: string
  /**
   *
   * @type {CardMtsOperDirection}
   * @memberof AccountOperationDetails
   */
  direction?: CardMtsOperDirection
}
/**
 *
 * @export
 * @enum {string}
 */
export enum AccountState {
  Unknown = 0,
  ACTIVE = 1,
  BLOCKED = 2,
  CLOSED = 3,
}

/**
 *
 * @export
 * @enum {string}
 */
export enum AccountType {
  Unknown = 0,
  SAVINGS_ACC = 1,
  SAVINGS_PLUS_ACC = 2,
  SAVING_WE_ACC = 3,
  CURRENT_ACC = 4,
  DEPOSIT_DEM_ACC = 5,
  DEPOSIT_ACC = 6,
  SAVINGS_CASHBACK_ACC = 7,
  CARD_ACC = 8,
  SAVINGS_MTS_ACC = 9,
}

/**
 *
 * @export
 * @interface Amount
 */
export interface Amount {
  /**
   *
   * @type {number}
   * @memberof Amount
   */
  base?: number
  /**
   *
   * @type {number}
   * @memberof Amount
   */
  total?: number
  /**
   *
   * @type {number}
   * @memberof Amount
   */
  fee?: number
  /**
   *
   * @type {Currency}
   * @memberof Amount
   */
  currency?: Currency
  /**
   *
   * @type {string}
   * @memberof Amount
   */
  currencyCode?: string
}
/**
 * Информация о счете
 * @export
 * @interface AmountInfo
 */
export interface AmountInfo {
  /**
   * Величина
   * @type {number}
   * @memberof AmountInfo
   */
  amount?: number
  /**
   *
   * @type {Currency}
   * @memberof AmountInfo
   */
  cur?: Currency
}
/**
 *
 * @export
 * @interface AmountValue
 */
export interface AmountValue {
  /**
   *
   * @type {number}
   * @memberof AmountValue
   */
  value?: number
  /**
   *
   * @type {Currency}
   * @memberof AmountValue
   */
  currency?: Currency
}
/**
 *
 * @export
 * @enum {string}
 */
export enum ApCondition {
  UNDEFINED = 0,
  THRESHOLD = 1,
  SCHEDULE = 2,
  BILL = 3,
}

/**
 *
 * @export
 * @interface ApCreationData
 */
export interface ApCreationData {
  /**
   * Описание автоматического платежа, указанное пользователем
   * @type {string}
   * @memberof ApCreationData
   */
  mnemonic?: string
  /**
   * Дата начала действия автоплатежа
   * @type {string}
   * @memberof ApCreationData
   */
  beginDate?: string
  /**
   * Дата окончания действия автоплатежа
   * @type {string}
   * @memberof ApCreationData
   */
  endDate?: string
  /**
   * Сумма платежа
   * @type {number}
   * @memberof ApCreationData
   */
  amount?: number
  /**
   *
   * @type {Currency}
   * @memberof ApCreationData
   */
  currency?: Currency
  /**
   * Условия выполнения автоплатежа: THRESHOLD – по достижению порогового значения доступного остатка, SCHEDULE – платеж по расписанию
   * @type {string}
   * @memberof ApCreationData
   */
  apCondition?: string
  /**
   *
   * @type {CurrencyAmount}
   * @memberof ApCreationData
   */
  balanceThreshold?: CurrencyAmount
  /**
   *
   * @type {CurrencyAmount}
   * @memberof ApCreationData
   */
  monthlyLimit?: CurrencyAmount
  /**
   *
   * @type {Schedule}
   * @memberof ApCreationData
   */
  schedule?: Schedule
  /**
   * Признак включенного/выключенного СМС-уведомления о предстоящем АП  Если 0 – не информировать.
   * @type {number}
   * @memberof ApCreationData
   */
  paymentPreNotification?: number
  /**
   * Признак необходимости информирования клиента о платеже
   * @type {boolean}
   * @memberof ApCreationData
   */
  paymentNotification?: boolean
  /**
   * Возможные значения OTP_SMS_CALLBACK – операция ожидает подтверждения пользователя через смс
   * @type {string}
   * @memberof ApCreationData
   */
  confirmationType?: string
  /**
   *
   * @type {boolean}
   * @memberof ApCreationData
   */
  confirmationRequired?: boolean
  /**
   * День платежа по счету
   * @type {number}
   * @memberof ApCreationData
   */
  billPaymentDay?: number
}
/**
 *
 * @export
 * @interface ApplePayResponse
 */
export interface ApplePayResponse {
  /**
   *
   * @type {ResponseStatus}
   * @memberof ApplePayResponse
   */
  status?: ResponseStatus
  /**
   *
   * @type {ErrorWithCode}
   * @memberof ApplePayResponse
   */
  error?: ErrorWithCode
  /**
   *
   * @type {string}
   * @memberof ApplePayResponse
   */
  merchantSession?: string
}
/**
 *
 * @export
 * @interface Autopayment
 */
export interface Autopayment {
  /**
   * Уникальный идентификатор автоплатежа.
   * @type {string}
   * @memberof Autopayment
   */
  apId: string
  /**
   * Статус автоплатежа.
   * @type {string}
   * @memberof Autopayment
   */
  status?: string
  /**
   *
   * @type {SuspendInfo}
   * @memberof Autopayment
   */
  isSuspended?: SuspendInfo
  /**
   * Уникальный идентификатор Клиента (лица, которое финансирует автоплатеж) в ЭК
   * @type {string}
   * @memberof Autopayment
   */
  userId?: string
  /**
   * Уникальный идентификатор Платежного инструмента
   * @type {string}
   * @memberof Autopayment
   */
  bindingId?: string
  /**
   * Уникальный идентификатор поставщика
   * @type {string}
   * @memberof Autopayment
   */
  serviceId?: string
  /**
   * Атрибуты платежа.
   * @type {{ [key: string]: string; }}
   * @memberof Autopayment
   */
  serviceParams?: { [key: string]: string }
  /**
   * Описание автоматического платежа, указанное пользователем
   * @type {string}
   * @memberof Autopayment
   */
  mnemonic?: string
  /**
   * Дата начала действия автоплатежа
   * @type {string}
   * @memberof Autopayment
   */
  beginDate?: string
  /**
   * Дата окончания действия автоплатежа
   * @type {string}
   * @memberof Autopayment
   */
  endDate?: string
  /**
   * Сумма платежа
   * @type {number}
   * @memberof Autopayment
   */
  amount?: number
  /**
   * Признак необходимости информирования клиента о результате операции
   * @type {boolean}
   * @memberof Autopayment
   */
  paymentResultNotificationRequired?: boolean
  /**
   * Признак необходимости SMS-запроса акцепта платежей Клиентом
   * @type {boolean}
   * @memberof Autopayment
   */
  paymentAcceptRequired?: boolean
  /**
   *
   * @type {ThresholdConditions}
   * @memberof Autopayment
   */
  threshold?: ThresholdConditions
  /**
   *
   * @type {ScheduleConditions}
   * @memberof Autopayment
   */
  schedule?: ScheduleConditions
  /**
   *
   * @type {BillConditions}
   * @memberof Autopayment
   */
  bill?: BillConditions
  /**
   * Дата создания Автоплатежа
   * @type {string}
   * @memberof Autopayment
   */
  creationDate?: string
  /**
   *
   * @type {AutopaymentProcess}
   * @memberof Autopayment
   */
  latestFinishedProcess?: AutopaymentProcess
}
/**
 * Процесс управления автоплатежом.
 * @export
 * @interface AutopaymentProcess
 */
export interface AutopaymentProcess {
  /**
   * Тип процесса.
   * @type {string}
   * @memberof AutopaymentProcess
   */
  type: string
  /**
   * Результат процесса.
   * @type {string}
   * @memberof AutopaymentProcess
   */
  result: string
  /**
   * Дата завершения процесса.
   * @type {string}
   * @memberof AutopaymentProcess
   */
  finishDate: string
  /**
   * Причина неудачи подключения или изменения автоплатежа.
   * @type {string}
   * @memberof AutopaymentProcess
   */
  failureCause?: string
  /**
   * Детализация отказа со стороны мерчанта (для WebSite.Api.Models.Autopayment.AutopaymentProcess.FailureCause = !:AutopaymentFailureCause.REJECTED_BY_MERCHANT):  <list type=\"bullet\"><item><term>8030</term><description>На номер получателя уже подключен автоплатеж МТС по порогу баланса</description></item><item><term>8031</term><description>На номер получателя уже подключен автоплатеж Партнера по порогу баланса</description></item><item><term>8035</term><description>На лицевой счет получателя уже подключен автоплатеж по порогу баланса</description></item><item><term>8040</term><description>На номер получателя уже подключается автоплатеж МТС по порогу баланса</description></item><item><term>8041</term><description>На номер получателя уже подключается автоплатеж Партнера по порогу баланса</description></item><item><term>8045</term><description>На лицевой счет получателя уже подключается автоплатеж по порогу баланса</description></item><item><term>8050</term><description>На номер получателя недоступно подключение автоплатежа.Телефон не принадлежит МТС</description></item><item><term>8060</term><description>На номер получателя недоступно подключение автоплатежа. Прием платежей на указанный телефон запрещен</description></item><item><term>8070</term><description>На номер получателя недоступно подключение автоплатежа. Невозможно подключить контроль баланса</description></item><item><term>8080</term><description>Получатель не согласовал подключение автоплатежа</description></item><item><term>8500</term><description>Подключение автоплатежа не удалось по техническим причинам</description></item><item><term>NO_BILLING_ADDRESS</term><description>Не найден номер получателя</description></item><item><term>1</term><description>Техническая ошибка взаимодействия со сторонним ОСС (оператором сотовой связи) или посредником(Киберплат)</description></item><item><term>4</term><description>Клиент с указанным номером телефона/ номером л/с не найден среди клиентов ОСС</description></item><item><term>5</term><description>Операция не доступна для клиента ОСС с указанным номером телефона/ номером л/с</description></item><item><term>8</term><description>Недопустимое значение порога баланса для данного ОСС</description></item><item><term>10</term><description>Для указанного номера телефона в ОСС уже подключена услуга автоплатежа(другим партнером или Сервисом АП)</description></item><item><term>11</term><description>Абонент ОСС не согласовал подключение услуги автоплатежа</description></item><item><term>14</term><description>Автоплатеж для данного ОСС не может быть подключен на указанную сумму</description></item><item><term>иное или пустое значение</term><description> технические причины</description></item></list>
   * @type {string}
   * @memberof AutopaymentProcess
   */
  failureCauseDetails?: string
  /**
   * Дополнительные сведения об отказе со стороны мерчанта (для WebSite.Api.Models.Autopayment.AutopaymentProcess.FailureCause = !:AutopaymentFailureCause.REJECTED_BY_MERCHANT).
   * @type {string}
   * @memberof AutopaymentProcess
   */
  failureCauseMessage?: string
}
/**
 *
 * @export
 * @enum {string}
 */
export enum Availability {
  UNKNOWN = 0,
  AVAILABLE = 1,
  IRRELEVANT_ACCOUNTING_METHOD = 2,
  IRRELEVANT_JURIDICAL_CATEGORY = 3,
  AUTOPAYMENT_EXISTS = 4,
  PAYMENTS_DISABLED = 5,
  UNSUPPORTED_FOR_MERCHANT = 6,
}

/**
 *
 * @export
 * @interface AvailabilityInfo
 */
export interface AvailabilityInfo {
  /**
   *
   * @type {AvailabilityType}
   * @memberof AvailabilityInfo
   */
  type?: AvailabilityType
  /**
   *
   * @type {Availability}
   * @memberof AvailabilityInfo
   */
  availability?: Availability
  /**
   * Признак, указывающий, что клиент является владельцем уже подключенного АП по порогу или счету.
   * @type {boolean}
   * @memberof AvailabilityInfo
   */
  isOwner?: boolean
}
/**
 *
 * @export
 * @enum {string}
 */
export enum AvailabilityType {
  UNKNOWN = 0,
  BALANCE = 1,
  SCHEDULE = 2,
  BILL = 3,
}

/**
 * Информация о том, какие типы автоплатежа доступны а какие недоступны (с указанием причины).
 * @export
 * @interface AvailableTypesResult
 */
export interface AvailableTypesResult {
  /**
   * Массив параметров, описывающих доступность или недоступность каждого из 3 типов автоплатежей.
   * @type {Array<AvailabilityInfo>}
   * @memberof AvailableTypesResult
   */
  availableTypes?: Array<AvailabilityInfo>
  /**
   *
   * @type {ProviderParams}
   * @memberof AvailableTypesResult
   */
  providerParams?: ProviderParams
}
/**
 *
 * @export
 * @interface BankInfo
 */
export interface BankInfo {
  /**
   *
   * @type {string}
   * @memberof BankInfo
   */
  bic?: string
  /**
   *
   * @type {string}
   * @memberof BankInfo
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof BankInfo
   */
  correspondentAccount?: string
}
/**
 *
 * @export
 * @enum {string}
 */
export enum BankMtsCardType {
  DEBIT_CARD = 0,
  CREDIT_CARD = 1,
  OVERDRAFT_CARD = 2,
  VIRTUAL_CARD = 3,
  VIRT_CREDIT_CARD = 4,
  VIRT_DEBIT_CARD = 5,
  VIRT_DEBIT_CARD_LS = 6,
  VIRT_CREDIT_CARD_LS = 7,
}

/**
 *
 * @export
 * @interface Banner
 */
export interface Banner {
  /**
   *
   * @type {BannerVisibilityEnum}
   * @memberof Banner
   */
  visibility?: BannerVisibilityEnum
  /**
   *
   * @type {BannerPlaceEnum}
   * @memberof Banner
   */
  place?: BannerPlaceEnum
  /**
   *
   * @type {ForOperationTypeEnum}
   * @memberof Banner
   */
  forOperationType?: ForOperationTypeEnum
  /**
   * Иденентификаторы (через разделитель) ТСП или категории, для которых применим баннер
   * @type {string}
   * @memberof Banner
   */
  keyWords?: string
  /**
   * Иденентификаторы (через разделитель) ТСП или категории, для которых не применим баннер
   * @type {string}
   * @memberof Banner
   */
  excludeKeyWords?: string
  /**
   * Вес баннера (чем больше тем приоритетней. пока не используем, задел на влияние частоты показа)
   * @type {number}
   * @memberof Banner
   */
  weight?: number
  /**
   * Баннер является приоритетным(при наличие нескольких - предпочтение ему)
   * @type {boolean}
   * @memberof Banner
   */
  isPriority?: boolean
  /**
   * Содержимое баннера
   * @type {string}
   * @memberof Banner
   */
  content?: string
}
/**
 * Расположение баннера на странице
 * @export
 * @enum {string}
 */
export enum BannerPlaceEnum {
  None = 0,
  MainMiddle = 1,
  CardsMiddle = 2,
  MainBottom = 3,
  StartBottom = 4,
  Left = 5,
  Receipt = 6,
  ReceiptError = 7,
  ReceiptSuccess = 8,
  BankAccount = 9,
  StartTop = 10,
}

/**
 * Доступност баннера в зависимости от авторизации
 * @export
 * @enum {string}
 */
export enum BannerVisibilityEnum {
  Both = 0,
  Authorized = 1,
  Anonymous = 2,
}

/**
 * Набор параметров, для оплаты по счтеу
 * @export
 * @interface BillConditions
 */
export interface BillConditions {
  /**
   * День платежа
   * @type {number}
   * @memberof BillConditions
   */
  paymentDay?: number
}
/**
 *
 * @export
 * @interface Binding
 */
export interface Binding {
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  maskedPan?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  expiry?: string
  /**
   *
   * @type {boolean}
   * @memberof Binding
   */
  isExpired?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Binding
   */
  isExpires?: boolean
  /**
   * Баланс доступных средств на Платежном инструменте (если известен)
   * @type {number}
   * @memberof Binding
   */
  balance?: number
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  issuerCategory?: string
  /**
   * Дата регистрации Платежного инструмента (в ПЦ ЭК)
   * @type {string}
   * @memberof Binding
   */
  createdDate?: string
  /**
   * Дата последнего обновления Платежного инструмента  Равна дате создания, если с момента создания карта не была изменена
   * @type {string}
   * @memberof Binding
   */
  updatedDate?: string
  /**
   *
   * @type {BindingParam}
   * @memberof Binding
   */
  bindingParams?: BindingParam
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  phoneNumber?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  formatedPhoneNumber?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  maskedPhoneNumber?: string
  /**
   * Мнемоническое имя ПИ, заданное пользователем
   * @type {string}
   * @memberof Binding
   */
  mnemonic?: string
  /**
   *
   * @type {boolean}
   * @memberof Binding
   */
  isExternal?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Binding
   */
  is3DSecureBinding?: boolean
  /**
   *
   * @type {CardType}
   * @memberof Binding
   */
  cardType?: CardType
  /**
   *
   * @type {Array<BindingBlock>}
   * @memberof Binding
   */
  blocks?: Array<BindingBlock>
  /**
   *
   * @type {boolean}
   * @memberof Binding
   */
  isBlocked?: boolean
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  blockedFrom?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  masterpassToken?: string
  /**
   *
   * @type {boolean}
   * @memberof Binding
   */
  isMasterPass?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Binding
   */
  isMTSCashbackCard?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Binding
   */
  isMasterPassApplicable?: boolean
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  icon?: string
  /**
   * Цвет карты, присвоенный пользователем  Если карта привязана без указания цвета, она имеет цвет по  умолчанию (серый)  Формат – (r, g, b), где r, g и b имеют значение от 0 до 255
   * @type {string}
   * @memberof Binding
   */
  color?: string
  /**
   * Уникальный идентификатор Платежного инструмента (ПИ)
   * @type {string}
   * @memberof Binding
   */
  bindingId?: string
  /**
   *
   * @type {Currency}
   * @memberof Binding
   */
  currency?: Currency
  /**
   *
   * @type {BindingType}
   * @memberof Binding
   */
  bindingType?: BindingType
  /**
   *
   * @type {BindingStatus}
   * @memberof Binding
   */
  bindingStatus?: BindingStatus
  /**
   * Признак, является ли платежный инструмент используемым по умолчанию
   * @type {boolean}
   * @memberof Binding
   */
  isDefaultBinding?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Binding
   */
  isCard?: boolean
  /**
   *
   * @type {number}
   * @memberof Binding
   */
  errorCode?: number
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  errorCause?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  errorMessage?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  errorDesc?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  errorDescription?: string
  /**
   *
   * @type {ErrorType}
   * @memberof Binding
   */
  errorType?: ErrorType
}
/**
 *
 * @export
 * @interface BindingBlock
 */
export interface BindingBlock {
  /**
   *
   * @type {string}
   * @memberof BindingBlock
   */
  blockId?: string
  /**
   *
   * @type {BlockSource}
   * @memberof BindingBlock
   */
  source?: BlockSource
  /**
   *
   * @type {string}
   * @memberof BindingBlock
   */
  clientId?: string
  /**
   *
   * @type {BlockType}
   * @memberof BindingBlock
   */
  blockType?: BlockType
  /**
   *
   * @type {string}
   * @memberof BindingBlock
   */
  reasonCode?: string
  /**
   *
   * @type {string}
   * @memberof BindingBlock
   */
  reason?: string
  /**
   *
   * @type {string}
   * @memberof BindingBlock
   */
  blockDate?: string
}
/**
 *
 * @export
 * @interface BindingParam
 */
export interface BindingParam {
  /**
   *
   * @type {string}
   * @memberof BindingParam
   */
  color?: string
  /**
   *
   * @type {BankMtsCardType}
   * @memberof BindingParam
   */
  bankCardType?: BankMtsCardType
  /**
   *
   * @type {string}
   * @memberof BindingParam
   */
  bankHashPan?: string
  /**
   *
   * @type {string}
   * @memberof BindingParam
   */
  bankCardId?: string
  /**
   *
   * @type {string}
   * @memberof BindingParam
   */
  accountNumber?: string
  /**
   *
   * @type {AccountType}
   * @memberof BindingParam
   */
  accountType?: AccountType
  /**
   *
   * @type {AccountState}
   * @memberof BindingParam
   */
  accountState?: AccountState
  /**
   *
   * @type {boolean}
   * @memberof BindingParam
   */
  isHiddenByUser?: boolean
  /**
   *
   * @type {string}
   * @memberof BindingParam
   */
  productCode?: string
}
/**
 *
 * @export
 * @enum {string}
 */
export enum BindingStatus {
  Active = 0,
  Deactivated = 1,
  ToVerify = 2,
  Archived = 3,
}

/**
 *
 * @export
 * @interface BindingTerms
 */
export interface BindingTerms {
  /**
   *
   * @type {CardType}
   * @memberof BindingTerms
   */
  cardType?: CardType
  /**
   * Перечень категорий файла поставщиков, в пользу которых можно проводить операции данным ПИ  ///
   * @type {string}
   * @memberof BindingTerms
   */
  supportedCategories?: string
  /**
   * Лимит по максимальной сумме платежа за одну операцию
   * @type {number}
   * @memberof BindingTerms
   */
  operationAmount?: number
  /**
   * Код операции. 0 - все в порядке
   * @type {number}
   * @memberof BindingTerms
   */
  actionCode?: number
  /**
   *
   * @type {Amount}
   * @memberof BindingTerms
   */
  amount?: Amount
  /**
   * Уникальный номер операции в ПЦ
   * @type {string}
   * @memberof BindingTerms
   */
  mdOrder?: string
  /**
   * Платеж разрешен
   * @type {boolean}
   * @memberof BindingTerms
   */
  isPaymentAllowed?: boolean
  /**
   * Признак обязательности ввода кода CVV2/CVC2 для конкретного биндинга по конкретной операции
   * @type {boolean}
   * @memberof BindingTerms
   */
  cvcRequired?: boolean
  /**
   * Платежное средство, которое клиент указал в качестве предпочтитаемого при запросе расчета комиссии и лимитов
   * @type {boolean}
   * @memberof BindingTerms
   */
  userSelected?: boolean
  /**
   *
   * @type {ConvertedAmount}
   * @memberof BindingTerms
   */
  convertedAmount?: ConvertedAmount
  /**
   *
   * @type {number}
   * @memberof BindingTerms
   */
  minAmount?: number
  /**
   *
   * @type {number}
   * @memberof BindingTerms
   */
  maxAmount?: number
  /**
   * Уникальный идентификатор Платежного инструмента (ПИ)
   * @type {string}
   * @memberof BindingTerms
   */
  bindingId?: string
  /**
   *
   * @type {Currency}
   * @memberof BindingTerms
   */
  currency?: Currency
  /**
   *
   * @type {BindingType}
   * @memberof BindingTerms
   */
  bindingType?: BindingType
  /**
   *
   * @type {BindingStatus}
   * @memberof BindingTerms
   */
  bindingStatus?: BindingStatus
  /**
   * Признак, является ли платежный инструмент используемым по умолчанию
   * @type {boolean}
   * @memberof BindingTerms
   */
  isDefaultBinding?: boolean
  /**
   *
   * @type {boolean}
   * @memberof BindingTerms
   */
  isCard?: boolean
  /**
   *
   * @type {number}
   * @memberof BindingTerms
   */
  errorCode?: number
  /**
   *
   * @type {string}
   * @memberof BindingTerms
   */
  errorCause?: string
  /**
   *
   * @type {string}
   * @memberof BindingTerms
   */
  errorMessage?: string
  /**
   *
   * @type {string}
   * @memberof BindingTerms
   */
  errorDesc?: string
  /**
   *
   * @type {string}
   * @memberof BindingTerms
   */
  errorDescription?: string
  /**
   *
   * @type {ErrorType}
   * @memberof BindingTerms
   */
  errorType?: ErrorType
}
/**
 *
 * @export
 * @enum {string}
 */
export enum BindingType {
  UNKNOWN = 0,
  MTS_ACCOUNT = 1,
  EMONEY_ACCOUNT = 2,
  BOUND_CARD = 3,
  GENERAL_CARD = 4,
  ANONYMOUS_CARD = 5,
  TECHNICAL_ACCOUNT = 6,
  VIRTUAL_CARD = 7,
  EXTERNALLY_TOKENIZED_CARD = 8,
  VIRTUAL_CARD_LS = 9,
  BANK_ACCOUNT = 10,
  VIRT_CREDIT_CARD = 11,
  MASTERPASS_CARD = 100,
  APPLE_PAY = 101,
  SAMSUNG_PAY = 102,
  GOOGLE_PAY = 103,
  VTS_TOKEN = 104,
  MDES_TOKEN = 105,
  VIRT_DEBIT_CARD_LS = 106,
  APPLE_PAY_TOKEN = 107,
  GOOGLE_PAY_TOKEN = 108,
  SAMSUNG_PAY_TOKEN = 109,
}

/**
 *
 * @export
 * @enum {string}
 */
export enum BlockSource {
  UNKNOWN = 0,
  USER = 1,
  SYSTEM = 2,
}

/**
 *
 * @export
 * @enum {string}
 */
export enum BlockType {
  UNKNOWN = 0,
  FULL = 1,
  PARTIAL = 2,
}

/**
 *
 * @export
 * @enum {string}
 */
export enum CardMtsOperDirection {
  INCOME = 0,
  OUTCOME = 1,
}

/**
 *
 * @export
 * @enum {string}
 */
export enum CardType {
  UNKNOWN = 0,
  VISA = 1,
  MIR = 2,
  MASTERCARD = 3,
  MAESTRO = 4,
  CUP = 5,
  VIRTUAL = 6,
  UNIONPAY = 7,
}

/**
 *
 * @export
 * @interface CashBackBalanceResult
 */
export interface CashBackBalanceResult {
  /**
   * Текущее значение CashBack
   * @type {number}
   * @memberof CashBackBalanceResult
   */
  cashBackValue?: number
  /**
   * Общая сумма CashBack за все периоды
   * @type {number}
   * @memberof CashBackBalanceResult
   */
  allCashBackValue?: number
  /**
   * Текущее значение CashBack
   * @type {number}
   * @memberof CashBackBalanceResult
   */
  pendingCashBackValue?: number
  /**
   * Дата последней активности участника
   * @type {string}
   * @memberof CashBackBalanceResult
   */
  lastActivityDate?: string
}
/**
 *
 * @export
 * @interface CheckTransferRequest
 */
export interface CheckTransferRequest {
  /**
   *
   * @type {TransferByReqSource}
   * @memberof CheckTransferRequest
   */
  source: TransferByReqSource
  /**
   *
   * @type {TransferByReqTarget}
   * @memberof CheckTransferRequest
   */
  target: TransferByReqTarget
  /**
   *
   * @type {AmountValue}
   * @memberof CheckTransferRequest
   */
  operationAmount: AmountValue
  /**
   *
   * @type {VatEnum}
   * @memberof CheckTransferRequest
   */
  vat?: VatEnum
  /**
   * Назначение платежа
   * @type {string}
   * @memberof CheckTransferRequest
   */
  purpose?: string
  /**
   *
   * @type {JuridicalAddData}
   * @memberof CheckTransferRequest
   */
  additionalData?: JuridicalAddData
}
/**
 *
 * @export
 * @interface CheckTransferResponse
 */
export interface CheckTransferResponse {
  /**
   * Уникальный идентификатор перевода, используемый в последствии для проведения  операции с помощью doExtTransfer
   * @type {string}
   * @memberof CheckTransferResponse
   */
  transferId?: string
  /**
   * Номер платежного документа в системе ДБО Банка
   * @type {string}
   * @memberof CheckTransferResponse
   */
  docNumber?: string
  /**
   *
   * @type {AmountValue}
   * @memberof CheckTransferResponse
   */
  feeAmount?: AmountValue
  /**
   *
   * @type {string}
   * @memberof CheckTransferResponse
   */
  phone?: string
}
/**
 *
 * @export
 * @interface ConfirmBindingResponse
 */
export interface ConfirmBindingResponse {
  /**
   * ID созданной карты
   * @type {string}
   * @memberof ConfirmBindingResponse
   */
  createdBindingId?: string
  /**
   *
   * @type {string}
   * @memberof ConfirmBindingResponse
   */
  confirmationType?: string
  /**
   * Список плат. инструментов
   * @type {Array<Binding>}
   * @memberof ConfirmBindingResponse
   */
  bindings?: Array<Binding>
}
/**
 *
 * @export
 * @interface ConvertedAmount
 */
export interface ConvertedAmount {
  /**
   * Сумма в рублях
   * @type {number}
   * @memberof ConvertedAmount
   */
  baseAmount?: number
  /**
   * Сумма в целевой валюте
   * @type {number}
   * @memberof ConvertedAmount
   */
  amount?: number
  /**
   *
   * @type {Currency}
   * @memberof ConvertedAmount
   */
  currency?: Currency
  /**
   *
   * @type {number}
   * @memberof ConvertedAmount
   */
  rate?: number
  /**
   *
   * @type {number}
   * @memberof ConvertedAmount
   */
  unit?: number
}
/**
 * Запрос на создание автоплатежа
 * @export
 * @interface CreateAutopaymentRequest
 */
export interface CreateAutopaymentRequest {
  /**
   * Уникальный идентификатор существующей транзакции, на основании которой создается автоматический платеж
   * @type {string}
   * @memberof CreateAutopaymentRequest
   */
  mdOrder?: string
  /**
   *
   * @type {ApCreationData}
   * @memberof CreateAutopaymentRequest
   */
  apCreationData?: ApCreationData
  /**
   * Уникальный идентификатор ПИ
   * @type {string}
   * @memberof CreateAutopaymentRequest
   */
  bindingId?: string
  /**
   * Уникальный идентификатор поставщика
   * @type {string}
   * @memberof CreateAutopaymentRequest
   */
  serviceId?: string
  /**
   * Атрибуты платежа
   * @type {{ [key: string]: string; }}
   * @memberof CreateAutopaymentRequest
   */
  serviceParams?: { [key: string]: string }
  /**
   *
   * @type {boolean}
   * @memberof CreateAutopaymentRequest
   */
  operationConfirmationRequired?: boolean
  /**
   *
   * @type {boolean}
   * @memberof CreateAutopaymentRequest
   */
  overrideRecipientCurrentAutopayment?: boolean
  /**
   * Уникальный идентификатор автоплатежа в модуле регистрации автоплатежей
   * @type {string}
   * @memberof CreateAutopaymentRequest
   */
  apId?: string
  /**
   * Набор пар \"параметр\":\"значение\", описывающих контекст вызова операции витриной.
   * @type {{ [key: string]: string; }}
   * @memberof CreateAutopaymentRequest
   */
  partnerParams?: { [key: string]: string }
}
/**
 * Результат создания автоплатежа
 * @export
 * @interface CreateAutopaymentResult
 */
export interface CreateAutopaymentResult {
  /**
   * Уникальный идентификатор автоплатежа в модуле регистрации автоплатежей
   * @type {string}
   * @memberof CreateAutopaymentResult
   */
  apId?: string
  /**
   * Идентификатор ожидаемого от клиента подтверждения ранее запрошенной операции.  Наличие данного параметра означает необходимость ввода клиентом одноразового пароля  для подключения или редактирования автоплатежа (после выполнения операции createAutopayment или editAutopayment)  либо для замены платежного инструмента автоплатежей (после выполнения операции replaceBinding).
   * @type {string}
   * @memberof CreateAutopaymentResult
   */
  otpId?: string
}
/**
 * Создание нового ПИ
 * @export
 * @interface CreateBindingRequest
 */
export interface CreateBindingRequest {
  /**
   * Номер карты
   * @type {string}
   * @memberof CreateBindingRequest
   */
  pan?: string
  /**
   * Месяц действия карты
   * @type {number}
   * @memberof CreateBindingRequest
   */
  expiryMonth?: number
  /**
   * Год действия карты
   * @type {number}
   * @memberof CreateBindingRequest
   */
  expiryYear?: number
  /**
   * Имя держателя карты, opt
   * @type {string}
   * @memberof CreateBindingRequest
   */
  cardholderName?: string
  /**
   * Мнемоническое имя карты, req
   * @type {string}
   * @memberof CreateBindingRequest
   */
  mnemonic?: string
  /**
   * Признак, говорящий о желании пользователя использовать регистрируемую карту по умолчанию при платежах, opt
   * @type {boolean}
   * @memberof CreateBindingRequest
   */
  isDefaultBinding?: boolean
  /**
   * СVC-код
   * @type {string}
   * @memberof CreateBindingRequest
   */
  cvc?: string
  /**
   * Идентификатор bindingId существующей карты клиента, взамен которой привязывается новая карта
   * @type {string}
   * @memberof CreateBindingRequest
   */
  replacedBindingId?: string
}
/**
 * Результат создания нового ПИ
 * @export
 * @interface CreateBindingResult
 */
export interface CreateBindingResult {
  /**
   * ID созданной карты
   * @type {string}
   * @memberof CreateBindingResult
   */
  createdBindingId?: string
  /**
   * Список плат. инструментов
   * @type {Array<Binding>}
   * @memberof CreateBindingResult
   */
  bindings?: Array<Binding>
  /**
   * req, Уникальный номер операции в ПЦ ЭК
   * @type {string}
   * @memberof CreateBindingResult
   */
  mdOrder?: string
  /**
   * req/opt, Параметр для проведения процедуры 3DSecure Если присутствует в ответе, то карта вовлечена в 3DSecure (Обязательный, если карта вовлечена в программу 3DS)
   * @type {string}
   * @memberof CreateBindingResult
   */
  paReq?: string
  /**
   * req/opt, URL-адрес банка эмитента (сервер ACS), на который клиент должен быть перенаправлен (Обязательный, если карта вовлечена в программу 3DS)
   * @type {string}
   * @memberof CreateBindingResult
   */
  acsUrl?: string
  /**
   * Данные запроса аутентификации у ACS эмитента. Challenge flow.
   * @type {string}
   * @memberof CreateBindingResult
   */
  challengeRequest?: string
  /**
   * opt/req, Маскированный номер карты, представляет собой первые 6 и последние 4 цифры номера карты в виде 123456*1234 (Обязательный, если карта вовлечена в программу 3DS)
   * @type {string}
   * @memberof CreateBindingResult
   */
  maskedPan?: string
  /**
   * req/opt, Тип карты  (Присутствует, если карта не вовлечена в программу 3DS)
   * @type {string}
   * @memberof CreateBindingResult
   */
  cardType?: string
  /**
   * Опциональный  Присутствует, если mdOrder соответстует платежу, обработанному без 3DSecure  В этом случае ПЦ проверит карту на вовлеченность повторно
   * @type {string}
   * @memberof CreateBindingResult
   */
  confirmationType?: string
  /**
   * Уникальный идентификатор транзакции 3DS 2.0. Обязателен при  FINISH_3DS2
   * @type {string}
   * @memberof CreateBindingResult
   */
  threeDsServerTransId?: string
  /**
   * URL 3D Secure метода ACS-сервера эмитента.
   * @type {string}
   * @memberof CreateBindingResult
   */
  threeDsMethodUrl?: string
  /**
   * BASE-64 данные для 3D Secure метода.
   * @type {string}
   * @memberof CreateBindingResult
   */
  threeDsMethodData?: string
}
/**
 *
 * @export
 * @interface CreateTransactionRequest
 */
export interface CreateTransactionRequest {
  /**
   *
   * @type {string}
   * @memberof CreateTransactionRequest
   */
  callback?: string
  /**
   *
   * @type {PaymentDetails}
   * @memberof CreateTransactionRequest
   */
  paymentDetails?: PaymentDetails
}
/**
 *
 * @export
 * @enum {string}
 */
export enum Currency {
  Unknown = 0,
  ALL = 8,
  DZD = 12,
  ARS = 32,
  AUD = 36,
  BSD = 44,
  BHD = 48,
  BDT = 50,
  AMD = 51,
  BBD = 52,
  BMD = 60,
  BTN = 64,
  BOB = 68,
  BWP = 72,
  BZD = 84,
  SBD = 90,
  BND = 96,
  MMK = 104,
  BIF = 108,
  KHR = 116,
  CAD = 124,
  CVE = 132,
  KYD = 136,
  LKR = 144,
  CLP = 152,
  CNY = 156,
  COP = 170,
  KMF = 174,
  CRC = 188,
  HRK = 191,
  CUP = 192,
  CZK = 203,
  DKK = 208,
  DOP = 214,
  SVC = 222,
  ETB = 230,
  ERN = 232,
  FKP = 238,
  FJD = 242,
  DJF = 262,
  GMD = 270,
  GIP = 292,
  GTQ = 320,
  GNF = 324,
  GYD = 328,
  HTG = 332,
  HNL = 340,
  HKD = 344,
  HUF = 348,
  ISK = 352,
  INR = 356,
  IDR = 360,
  IRR = 364,
  IQD = 368,
  ILS = 376,
  JMD = 388,
  JPY = 392,
  KZT = 398,
  JOD = 400,
  KES = 404,
  KPW = 408,
  KRW = 410,
  KWD = 414,
  KGS = 417,
  LAK = 418,
  LBP = 422,
  LSL = 426,
  LRD = 430,
  LYD = 434,
  MOP = 446,
  MWK = 454,
  MYR = 458,
  MVR = 462,
  MRO = 478,
  MUR = 480,
  MXN = 484,
  MNT = 496,
  MDL = 498,
  MAD = 504,
  OMR = 512,
  NAD = 516,
  NPR = 524,
  ANG = 532,
  AWG = 533,
  VUV = 548,
  NZD = 554,
  NIO = 558,
  NGN = 566,
  NOK = 578,
  PKR = 586,
  PAB = 590,
  PGK = 598,
  PYG = 600,
  PEN = 604,
  PHP = 608,
  QAR = 634,
  RUB = 643,
  RWF = 646,
  SHP = 654,
  STD = 678,
  SAR = 682,
  SCR = 690,
  SLL = 694,
  SGD = 702,
  VND = 704,
  SOS = 706,
  ZAR = 710,
  SSP = 728,
  SZL = 748,
  SEK = 752,
  CHF = 756,
  SYP = 760,
  THB = 764,
  TOP = 776,
  TTD = 780,
  AED = 784,
  TND = 788,
  UGX = 800,
  MKD = 807,
  RUR = 810,
  EGP = 818,
  GBP = 826,
  TZS = 834,
  USD = 840,
  UYU = 858,
  UZS = 860,
  WST = 882,
  YER = 886,
  TWD = 901,
  CUC = 931,
  ZWL = 932,
  BYN = 933,
  TMT = 934,
  GHS = 936,
  VEF = 937,
  SDG = 938,
  UYI = 940,
  RSD = 941,
  MZN = 943,
  AZN = 944,
  RON = 946,
  CHE = 947,
  CHW = 948,
  TRY = 949,
  XAF = 950,
  XCD = 951,
  XOF = 952,
  XPF = 953,
  XBA = 955,
  XBB = 956,
  XBC = 957,
  XBD = 958,
  XAU = 959,
  XDR = 960,
  XAG = 961,
  XPT = 962,
  XTS = 963,
  XPD = 964,
  XUA = 965,
  ZMW = 967,
  SRD = 968,
  MGA = 969,
  COU = 970,
  AFN = 971,
  TJS = 972,
  AOA = 973,
  BGN = 975,
  CDF = 976,
  BAM = 977,
  EUR = 978,
  MXV = 979,
  UAH = 980,
  GEL = 981,
  BOV = 984,
  PLN = 985,
  BRL = 986,
  CLF = 990,
  XSU = 994,
  USN = 997,
  XXX = 999,
}

/**
 *
 * @export
 * @interface CurrencyAmount
 */
export interface CurrencyAmount {
  /**
   * Сумма платежа
   * @type {number}
   * @memberof CurrencyAmount
   */
  amount?: number
  /**
   *
   * @type {Currency}
   * @memberof CurrencyAmount
   */
  currency?: Currency
}
/**
 * Запрос на удаление автоплатежа
 * @export
 * @interface DeleteAutopaymentRequest
 */
export interface DeleteAutopaymentRequest {
  /**
   * Уникальный идентификатор автоплатежа в модуле регистрации автоплатежей
   * @type {string}
   * @memberof DeleteAutopaymentRequest
   */
  apId?: string
  /**
   * Набор пар \"параметр\":\"значение\", описывающих контекст вызова операции витриной.
   * @type {{ [key: string]: string; }}
   * @memberof DeleteAutopaymentRequest
   */
  partnerParams?: { [key: string]: string }
}
/**
 * Запрос на редактирование автоплатежа
 * @export
 * @interface EditAutopaymentRequest
 */
export interface EditAutopaymentRequest {
  /**
   * Уникальный идентификатор продукта клиента
   * @type {string}
   * @memberof EditAutopaymentRequest
   */
  bindingId?: string
  /**
   * Описание автоматического платежа, указанное пользователем
   * @type {string}
   * @memberof EditAutopaymentRequest
   */
  mnemonic?: string
  /**
   * Дата начала действия автоплатежа
   * @type {string}
   * @memberof EditAutopaymentRequest
   */
  beginDate?: string
  /**
   * Дата окончания действия автоплатежа
   * @type {string}
   * @memberof EditAutopaymentRequest
   */
  endDate?: string
  /**
   * Сумма платежа
   * @type {number}
   * @memberof EditAutopaymentRequest
   */
  amount?: number
  /**
   * Признак необходимости SMS-запроса акцепта платежей Клиентом
   * @type {boolean}
   * @memberof EditAutopaymentRequest
   */
  paymentAcceptRequired?: boolean
  /**
   * Порог баланса лицевого счета, после которого возникает необходимость автоплатежа
   * @type {number}
   * @memberof EditAutopaymentRequest
   */
  balanceThreshold?: number
  /**
   * Месячный лимит на аггрегированную сумму платежей
   * @type {number}
   * @memberof EditAutopaymentRequest
   */
  monthlyPaymentsLimit?: number
  /**
   * Номер дня выполнения платежа в месяце
   * @type {number}
   * @memberof EditAutopaymentRequest
   */
  dayOfMonth?: number
  /**
   * День недели выполнения платежа
   * @type {number}
   * @memberof EditAutopaymentRequest
   */
  dayOfWeek?: number
  /**
   * Период выполнения платежей в днях. Значения от 1 до 180.
   * @type {number}
   * @memberof EditAutopaymentRequest
   */
  recurrencePeriod?: number
  /**
   * Дата выполнения платежа – для расписания в фиксированную дату
   * @type {string}
   * @memberof EditAutopaymentRequest
   */
  fixedDate?: string
  /**
   * Время срабатывания расписания
   * @type {string}
   * @memberof EditAutopaymentRequest
   */
  actuationTime?: string
  /**
   * Временная зона, относительно которой указано время
   * @type {string}
   * @memberof EditAutopaymentRequest
   */
  timeZone?: string
  /**
   * Признак включенного/выключенного СМС-уведомления о предстоящем АП
   * @type {number}
   * @memberof EditAutopaymentRequest
   */
  paymentPreNotificationPeriod?: number
  /**
   * День платежа по счету
   * @type {number}
   * @memberof EditAutopaymentRequest
   */
  billPaymentDay?: number
  /**
   *
   * @type {ApCondition}
   * @memberof EditAutopaymentRequest
   */
  apType?: ApCondition
  /**
   *
   * @type {ScheduleType}
   * @memberof EditAutopaymentRequest
   */
  scheduleType?: ScheduleType
  /**
   * Признак необходимости информирования клиента о результате операции   ///
   * @type {boolean}
   * @memberof EditAutopaymentRequest
   */
  paymentResultNotificationRequired?: boolean
  /**
   * Уникальный идентификатор автоплатежа в модуле регистрации автоплатежей
   * @type {string}
   * @memberof EditAutopaymentRequest
   */
  apId?: string
  /**
   * Набор пар \"параметр\":\"значение\", описывающих контекст вызова операции витриной.
   * @type {{ [key: string]: string; }}
   * @memberof EditAutopaymentRequest
   */
  partnerParams?: { [key: string]: string }
}
/**
 *
 * @export
 * @interface ErrorMessage
 */
export interface ErrorMessage {
  /**
   *
   * @type {number}
   * @memberof ErrorMessage
   */
  code?: number
  /**
   *
   * @type {string}
   * @memberof ErrorMessage
   */
  message?: string
}
/**
 *
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
  /**
   *
   * @type {boolean}
   * @memberof ErrorResponse
   */
  success?: boolean
  /**
   *
   * @type {Error}
   * @memberof ErrorResponse
   */
  error?: Error
}
/**
 *
 * @export
 * @enum {string}
 */
export enum ErrorType {
  None = 0,
  Security = 1,
  PARTNER_AUTH = 2,
}

/**
 *
 * @export
 * @interface ErrorWithCode
 */
export interface ErrorWithCode {
  /**
   *
   * @type {number}
   * @memberof ErrorWithCode
   */
  errorCode?: number
  /**
   *
   * @type {string}
   * @memberof ErrorWithCode
   */
  errorDescription?: string
  /**
   *
   * @type {string}
   * @memberof ErrorWithCode
   */
  message?: string
}
/**
 *
 * @export
 * @interface ExTransferRequest
 */
export interface ExTransferRequest {
  /**
   *
   * @type {string}
   * @memberof ExTransferRequest
   */
  transferId?: string
  /**
   *
   * @type {string}
   * @memberof ExTransferRequest
   */
  otp?: string
  /**
   *
   * @type {string}
   * @memberof ExTransferRequest
   */
  otpId?: string
}
/**
 *
 * @export
 * @interface ExTransferResponse
 */
export interface ExTransferResponse {
  /**
   *
   * @type {string}
   * @memberof ExTransferResponse
   */
  transferId?: string
  /**
   *
   * @type {string}
   * @memberof ExTransferResponse
   */
  state?: string
  /**
   *
   * @type {string}
   * @memberof ExTransferResponse
   */
  stateDetail?: string
  /**
   *
   * @type {string}
   * @memberof ExTransferResponse
   */
  operationId?: string
  /**
   *
   * @type {string}
   * @memberof ExTransferResponse
   */
  sbpOperId?: string
}
/**
 * Данные запроса на завершение операции с 3DSecure
 * @export
 * @interface Finish3DsRequest
 */
export interface Finish3DsRequest {
  /**
   * Уникальный номер операции в ПЦ ЭК, полученный в ответе на payment
   * @type {string}
   * @memberof Finish3DsRequest
   */
  mdOrder?: string
  /**
   * Параметр, который был получен от ACS банка эмитента после прохождения 3DSecure
   * @type {string}
   * @memberof Finish3DsRequest
   */
  xRes?: string
}
/**
 * Тип операции для которой отображается баннер
 * @export
 * @enum {string}
 */
export enum ForOperationTypeEnum {
  Any = 0,
  Payment = 1,
  Transfer = 2,
}

/**
 *
 * @export
 * @interface ForeignTransactionData
 */
export interface ForeignTransactionData {
  /**
   *
   * @type {MerchantInfo}
   * @memberof ForeignTransactionData
   */
  merchantInfo?: MerchantInfo
}
/**
 *
 * @export
 * @interface GetAccountOperationsResponse
 */
export interface GetAccountOperationsResponse {
  /**
   *
   * @type {Array<AccountOperation>}
   * @memberof GetAccountOperationsResponse
   */
  operations?: Array<AccountOperation>
}
/**
 * Запрос на получение списка автоплатежей
 * @export
 * @interface GetAutopaymentsRequest
 */
export interface GetAutopaymentsRequest {
  /**
   * Уникальный идентификатор Платежного инструмента в ЭК, автоплатежи которого требуется получить.
   * @type {string}
   * @memberof GetAutopaymentsRequest
   */
  bindingId?: string
  /**
   * Признак, указывающий, что не требуется получать неактивные автоплатежи,  находящиеся в конечных статусах (ACTIVATION_FAILURE и INACTIVE).  Если не задан, будут возвращены автоплатежи во всех статусах.
   * @type {boolean}
   * @memberof GetAutopaymentsRequest
   */
  excludeTerminalStatuses?: boolean
  /**
   * Уникальный идентификатор автоплатежа в модуле регистрации автоплатежей
   * @type {string}
   * @memberof GetAutopaymentsRequest
   */
  apId?: string
  /**
   * Набор пар \"параметр\":\"значение\", описывающих контекст вызова операции витриной.
   * @type {{ [key: string]: string; }}
   * @memberof GetAutopaymentsRequest
   */
  partnerParams?: { [key: string]: string }
}
/**
 *
 * @export
 * @interface GetAutopaymentsResult
 */
export interface GetAutopaymentsResult {
  /**
   * Идентификатор ожидаемого от клиента подтверждения ранее запрошенной операции.  Наличие данного параметра означает необходимость ввода клиентом одноразового пароля  для подключения или редактирования автоплатежа (после выполнения операции createAutopayment или editAutopayment)  либо для замены платежного инструмента автоплатежей (после выполнения операции replaceBinding).
   * @type {string}
   * @memberof GetAutopaymentsResult
   */
  otpId?: string
  /**
   * Информация об автоплатежах, удовлетворяющих условиям запроса.  Если Автоплатежей несколько, то возвращается несколько массивов.  Если ни одного Автоплатежа не найдено, не заполняется.
   * @type {Array<Autopayment>}
   * @memberof GetAutopaymentsResult
   */
  autopayments?: Array<Autopayment>
}
/**
 *
 * @export
 * @interface GetBindingResponse
 */
export interface GetBindingResponse {
  /**
   *
   * @type {Binding}
   * @memberof GetBindingResponse
   */
  result?: Binding
}
/**
 *
 * @export
 * @interface GetBindingsRequest
 */
export interface GetBindingsRequest {
  /**
   *
   * @type {Array<BindingStatus>}
   * @memberof GetBindingsRequest
   */
  statuses?: Array<BindingStatus>
  /**
   *
   * @type {Array<BindingParam>}
   * @memberof GetBindingsRequest
   */
  parameters?: Array<BindingParam>
  /**
   *
   * @type {Array<BindingType>}
   * @memberof GetBindingsRequest
   */
  filteredTypes?: Array<BindingType>
}
/**
 *
 * @export
 * @interface GetBindingsResponse
 */
export interface GetBindingsResponse {
  /**
   *
   * @type {Array<Binding>}
   * @memberof GetBindingsResponse
   */
  bindings?: Array<Binding>
}
/**
 *
 * @export
 * @interface GetLoansListResponse
 */
export interface GetLoansListResponse {
  /**
   *
   * @type {string}
   * @memberof GetLoansListResponse
   */
  rqid?: string
  /**
   *
   * @type {Array<LoanInfo>}
   * @memberof GetLoansListResponse
   */
  loans?: Array<LoanInfo>
}
/**
 *
 * @export
 * @interface GetMncResult
 */
export interface GetMncResult {
  /**
   *
   * @type {number}
   * @memberof GetMncResult
   */
  errorCode?: number
  /**
   *
   * @type {string}
   * @memberof GetMncResult
   */
  serviceId?: string
  /**
   *
   * @type {string}
   * @memberof GetMncResult
   */
  iconUrl?: string
  /**
   *
   * @type {string}
   * @memberof GetMncResult
   */
  message?: string
  /**
   *
   * @type {string}
   * @memberof GetMncResult
   */
  paramName?: string
}
/**
 * запрос расчета комиссий и лимитов платежа/перевода:
 * @export
 * @interface GetPaymentTermRequest
 */
export interface GetPaymentTermRequest {
  /**
   * Уникальный идентификатор Платежного инструмента
   * @type {string}
   * @memberof GetPaymentTermRequest
   */
  bindingId?: string
  /**
   * Номер карты
   * @type {string}
   * @memberof GetPaymentTermRequest
   */
  pan?: string
  /**
   * Год и месяц действия карты.
   * @type {string}
   * @memberof GetPaymentTermRequest
   */
  expiry?: string
  /**
   * Имя держателя карты
   * @type {string}
   * @memberof GetPaymentTermRequest
   */
  cardholderName?: string
  /**
   * СVC-код
   * @type {string}
   * @memberof GetPaymentTermRequest
   */
  cvc?: string
  /**
   * Уникальный идентификатор поставщика
   * @type {string}
   * @memberof GetPaymentTermRequest
   */
  serviceId?: string
  /**
   * Сумма заказа
   * @type {number}
   * @memberof GetPaymentTermRequest
   */
  amount?: number
  /**
   *
   * @type {Currency}
   * @memberof GetPaymentTermRequest
   */
  currency?: Currency
  /**
   * Атрибуты конкретного поставщика.
   * @type {{ [key: string]: string; }}
   * @memberof GetPaymentTermRequest
   */
  serviceParams?: { [key: string]: string }
  /**
   * Операция с ПИ Masterpass
   * @type {string}
   * @memberof GetPaymentTermRequest
   */
  masterpassOperationId?: string
}
/**
 * Информация о размере комиссий и лимитах в зависимости от средства платежа, используемого для оплаты.
 * @export
 * @interface GetPaymentTermsResult
 */
export interface GetPaymentTermsResult {
  /**
   *
   * @type {ServiceInfo}
   * @memberof GetPaymentTermsResult
   */
  service?: ServiceInfo
  /**
   * Параметры продукта
   * @type {Array<BindingTerms>}
   * @memberof GetPaymentTermsResult
   */
  bindings?: Array<BindingTerms>
}
/**
 *
 * @export
 * @interface GetTransferTermsRequest
 */
export interface GetTransferTermsRequest {
  /**
   *
   * @type {TransferType}
   * @memberof GetTransferTermsRequest
   */
  type?: TransferType
  /**
   * Уникальный идентификатор Платежного инструмента
   * @type {string}
   * @memberof GetTransferTermsRequest
   */
  bindingId?: string
  /**
   * Номер карты, с которой осуществляется перевод
   * @type {string}
   * @memberof GetTransferTermsRequest
   */
  pan?: string
  /**
   * Год и месяц действия карты, с которой осуществляется перевод
   * @type {string}
   * @memberof GetTransferTermsRequest
   */
  expiry?: string
  /**
   * Имя держателя карты, с которой осуществляется перевод
   * @type {string}
   * @memberof GetTransferTermsRequest
   */
  cardholderName?: string
  /**
   * СVC-код, с которой осуществляется перевод
   * @type {string}
   * @memberof GetTransferTermsRequest
   */
  cvc?: string
  /**
   * Уникальный идентификатор Платежного инструмента, получателя перевода
   * @type {string}
   * @memberof GetTransferTermsRequest
   */
  targetBindingId?: string
  /**
   * Номер карты, на которую осуществляется перевод
   * @type {string}
   * @memberof GetTransferTermsRequest
   */
  targetPan?: string
  /**
   * токенированный TargetPan.
   * @type {string}
   * @memberof GetTransferTermsRequest
   */
  tokenizedTargetPan?: string
  /**
   *
   * @type {PaymentToPhoneServiceInfo}
   * @memberof GetTransferTermsRequest
   */
  phonePaymentInfo?: PaymentToPhoneServiceInfo
  /**
   * Сумма, которая должна быть отправлена (без учета комиссии).
   * @type {number}
   * @memberof GetTransferTermsRequest
   */
  amount?: number
  /**
   * Валюта заказа
   * @type {number}
   * @memberof GetTransferTermsRequest
   */
  currency?: number
  /**
   *
   * @type {string}
   * @memberof GetTransferTermsRequest
   */
  masterpassOperationId?: string
}
/**
 *
 * @export
 * @interface GetTransferTermsResponse
 */
export interface GetTransferTermsResponse {
  /**
   * Уникальный номер операции в ПЦ ЭК
   * @type {string}
   * @memberof GetTransferTermsResponse
   */
  mdOrder?: string
  /**
   *
   * @type {Amount}
   * @memberof GetTransferTermsResponse
   */
  amount?: Amount
  /**
   * Минимально разрешенный порог
   * @type {number}
   * @memberof GetTransferTermsResponse
   */
  minAmount?: number
  /**
   * Максимально разрешенный порог
   * @type {number}
   * @memberof GetTransferTermsResponse
   */
  maxAmount?: number
}
/**
 *
 * @export
 * @interface GetTransferTypeRequest
 */
export interface GetTransferTypeRequest {
  /**
   *
   * @type {string}
   * @memberof GetTransferTypeRequest
   */
  accountNumber?: string
  /**
   *
   * @type {string}
   * @memberof GetTransferTypeRequest
   */
  bic?: string
  /**
   *
   * @type {string}
   * @memberof GetTransferTypeRequest
   */
  tin?: string
}
/**
 *
 * @export
 * @interface GetTransferTypeResult
 */
export interface GetTransferTypeResult {
  /**
   * Тип перевода. Возможные значения:  «PERSON» - физическому лицу;  «JURIDICAL» - юридическому лицу/ ИП;  «BUDGET» - в бюджетную организацию;  «SERVICEPAY» - сервисные переводы;  «UNDEFINED» - тип перевода не определен.
   * @type {string}
   * @memberof GetTransferTypeResult
   */
  transferType?: string
  /**
   * Флаг принадлежности счета МТС Банку
   * @type {boolean}
   * @memberof GetTransferTypeResult
   */
  isMTSBankBIC?: boolean
  /**
   * Код организации в реестре МТС
   * @type {string}
   * @memberof GetTransferTypeResult
   */
  code?: string
  /**
   * Буквенный ISO код валюты счёта
   * @type {string}
   * @memberof GetTransferTypeResult
   */
  currency?: string
}
/**
 *
 * @export
 * @interface HashItResponce
 */
export interface HashItResponce {
  /**
   *
   * @type {string}
   * @memberof HashItResponce
   */
  hash?: string
}
/**
 *
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
  /**
   *
   * @type {string}
   * @memberof InlineObject
   */
  threeDSMethodData: string
}
/**
 *
 * @export
 * @interface JuridicalAddData
 */
export interface JuridicalAddData {
  /**
   *
   * @type {string}
   * @memberof JuridicalAddData
   */
  paymentPeriod?: string
  /**
   *
   * @type {string}
   * @memberof JuridicalAddData
   */
  documentId?: string
  /**
   *
   * @type {string}
   * @memberof JuridicalAddData
   */
  serviceId?: string
  /**
   *
   * @type {string}
   * @memberof JuridicalAddData
   */
  documentNumber?: string
  /**
   *
   * @type {string}
   * @memberof JuridicalAddData
   */
  singleAccountNumber?: string
  /**
   *
   * @type {string}
   * @memberof JuridicalAddData
   */
  accountNumber?: string
  /**
   *
   * @type {string}
   * @memberof JuridicalAddData
   */
  codeFIAS?: string
}
/**
 * Информация о кредите
 * @export
 * @interface LoanInfo
 */
export interface LoanInfo {
  /**
   * Наименование продукта
   * @type {string}
   * @memberof LoanInfo
   */
  name?: string
  /**
   * Идентификатор кредита
   * @type {string}
   * @memberof LoanInfo
   */
  loanId?: string
  /**
   *
   * @type {Currency}
   * @memberof LoanInfo
   */
  currency?: Currency
  /**
   * Дата заключения договора
   * @type {string}
   * @memberof LoanInfo
   */
  startDate?: string
  /**
   * Дата окончания действия договора
   * @type {string}
   * @memberof LoanInfo
   */
  closeDate?: string
  /**
   * Номер договора
   * @type {string}
   * @memberof LoanInfo
   */
  agreementId?: string
  /**
   * Флаг наличия просрочки
   * @type {boolean}
   * @memberof LoanInfo
   */
  hasDelinq?: boolean
  /**
   *
   * @type {LoanTermInfo}
   * @memberof LoanInfo
   */
  termInfo?: LoanTermInfo
  /**
   *
   * @type {LoanRateInfo}
   * @memberof LoanInfo
   */
  rateInfo?: LoanRateInfo
  /**
   *
   * @type {AmountInfo}
   * @memberof LoanInfo
   */
  loanAmount?: AmountInfo
  /**
   *
   * @type {AmountInfo}
   * @memberof LoanInfo
   */
  debtAmount?: AmountInfo
  /**
   *
   * @type {LoanNextPmtInfo}
   * @memberof LoanInfo
   */
  nextPmtInfo?: LoanNextPmtInfo
  /**
   *
   * @type {LoanRepAccountInfo}
   * @memberof LoanInfo
   */
  repAccountInfo?: LoanRepAccountInfo
  /**
   *
   * @type {LoanRepaymentInfo}
   * @memberof LoanInfo
   */
  repaymentInfo?: LoanRepaymentInfo
}
/**
 * Информация о плановом платеже
 * @export
 * @interface LoanNextPmtInfo
 */
export interface LoanNextPmtInfo {
  /**
   * Дата планового платежа
   * @type {string}
   * @memberof LoanNextPmtInfo
   */
  pmtDt?: string
  /**
   * Сумма платежа
   * @type {number}
   * @memberof LoanNextPmtInfo
   */
  amount?: number
  /**
   *
   * @type {Currency}
   * @memberof LoanNextPmtInfo
   */
  cur?: Currency
  /**
   *
   * @type {AmountInfo}
   * @memberof LoanNextPmtInfo
   */
  amtToPay?: AmountInfo
  /**
   *
   * @type {LoanNextPmtParts}
   * @memberof LoanNextPmtInfo
   */
  nextPmtParts?: LoanNextPmtParts
}
/**
 *
 * @export
 * @interface LoanNextPmtParts
 */
export interface LoanNextPmtParts {
  /**
   *
   * @type {AmountInfo}
   * @memberof LoanNextPmtParts
   */
  debtMain?: AmountInfo
  /**
   *
   * @type {AmountInfo}
   * @memberof LoanNextPmtParts
   */
  debtPrcAll?: AmountInfo
  /**
   *
   * @type {AmountInfo}
   * @memberof LoanNextPmtParts
   */
  debtMainOver?: AmountInfo
  /**
   *
   * @type {AmountInfo}
   * @memberof LoanNextPmtParts
   */
  debtFine?: AmountInfo
}
/**
 * Информация о процентной ставке
 * @export
 * @interface LoanRateInfo
 */
export interface LoanRateInfo {
  /**
   * Процентная ставка
   * @type {number}
   * @memberof LoanRateInfo
   */
  rate?: number
}
/**
 * Информация о счете для погашения кредита
 * @export
 * @interface LoanRepAccountInfo
 */
export interface LoanRepAccountInfo {
  /**
   * Номер счета для погашения кредита
   * @type {string}
   * @memberof LoanRepAccountInfo
   */
  number?: string
  /**
   * Сумма
   * @type {number}
   * @memberof LoanRepAccountInfo
   */
  amount?: number
  /**
   *
   * @type {Currency}
   * @memberof LoanRepAccountInfo
   */
  cur?: Currency
}
/**
 * Информация о досрочном погашении
 * @export
 * @interface LoanRepaymentInfo
 */
export interface LoanRepaymentInfo {
  /**
   *
   * @type {RepaymentTypeEnum}
   * @memberof LoanRepaymentInfo
   */
  repaymentType?: RepaymentTypeEnum
  /**
   * Признак произвольной даты погашения для частичного досрочного погашения
   * @type {boolean}
   * @memberof LoanRepaymentInfo
   */
  isAnyDate?: boolean
  /**
   * Признак автоплатежа с уменьшением срока
   * @type {boolean}
   * @memberof LoanRepaymentInfo
   */
  isAuto?: boolean
  /**
   * Признак погашена ли полностью плановая операция по кредиту в текущем операционном дне.  Возможные значения:      true – плановая операция погашена;      false – плановая операция не погашена, либо погашена частично.
   * @type {boolean}
   * @memberof LoanRepaymentInfo
   */
  isLoanPayment?: boolean
}
/**
 * Информация о сроке кредита
 * @export
 * @interface LoanTermInfo
 */
export interface LoanTermInfo {
  /**
   * Величина
   * @type {number}
   * @memberof LoanTermInfo
   */
  count?: number
  /**
   *
   * @type {TermsUnit}
   * @memberof LoanTermInfo
   */
  unit?: TermsUnit
}
/**
 *
 * @export
 * @interface Merchant
 */
export interface Merchant {
  /**
   *
   * @type {string}
   * @memberof Merchant
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof Merchant
   */
  reference?: string
  /**
   *
   * @type {string}
   * @memberof Merchant
   */
  url?: string
}
/**
 *
 * @export
 * @interface MerchantInfo
 */
export interface MerchantInfo {
  /**
   *
   * @type {string}
   * @memberof MerchantInfo
   */
  mcc?: string
  /**
   *
   * @type {string}
   * @memberof MerchantInfo
   */
  mccDesc?: string
  /**
   *
   * @type {string}
   * @memberof MerchantInfo
   */
  terminalLocation?: string
  /**
   *
   * @type {string}
   * @memberof MerchantInfo
   */
  merchantId?: string
  /**
   *
   * @type {string}
   * @memberof MerchantInfo
   */
  terminalId?: string
}
/**
 *
 * @export
 * @interface ModelError
 */
export interface ModelError {
  /**
   *
   * @type {number}
   * @memberof ModelError
   */
  code?: number
  /**
   *
   * @type {string}
   * @memberof ModelError
   */
  message?: string
  /**
   *
   * @type {string}
   * @memberof ModelError
   */
  techMessage?: string
  /**
   *
   * @type {string}
   * @memberof ModelError
   */
  externalCode?: string
  /**
   *
   * @type {string}
   * @memberof ModelError
   */
  details?: string
}
/**
 *
 * @export
 * @interface MtsClientInfo
 */
export interface MtsClientInfo {
  /**
   * ФИО
   * @type {string}
   * @memberof MtsClientInfo
   */
  fullName?: string
  /**
   * Юридическая категория клиента  NATURAL_PERSON - физическое лицо  INDIVIDUAL_BUSINESSMAN - индивидуальный предприниматель
   * @type {string}
   * @memberof MtsClientInfo
   */
  juridicalCategory?: string
  /**
   * Привелегерованность клиента
   * @type {boolean}
   * @memberof MtsClientInfo
   */
  isVip?: boolean
}
/**
 *
 * @export
 * @enum {string}
 */
export enum OperationConfirmationType {
  NONE = 0,
  OTP_PAYMENT_PAGE = 1,
  OTP_SMS_CALLBACK = 2,
  FINISH_3DS = 3,
  FINISH_3DS2 = 4,
}

/**
 *
 * @export
 * @interface OperationDetails
 */
export interface OperationDetails {
  /**
   * Уникальный номер операции в ПЦ ЭК
   * @type {string}
   * @memberof OperationDetails
   */
  mdOrder?: string
  /**
   *
   * @type {OperationStatusType}
   * @memberof OperationDetails
   */
  state?: OperationStatusType
  /**
   * Признак терминалього состояния операции
   * @type {boolean}
   * @memberof OperationDetails
   */
  isFinishStage?: boolean
  /**
   * Дата и время совершения операции
   * @type {string}
   * @memberof OperationDetails
   */
  date?: string
  /**
   * Номер ссылки из процессинга
   * @type {string}
   * @memberof OperationDetails
   */
  refNumber?: string
  /**
   *
   * @type {OperationService}
   * @memberof OperationDetails
   */
  service?: OperationService
  /**
   *
   * @type {Amount}
   * @memberof OperationDetails
   */
  amount?: Amount
  /**
   *
   * @type {Binding}
   * @memberof OperationDetails
   */
  srcBinding?: Binding
  /**
   * Код завершения обработки операции
   * @type {number}
   * @memberof OperationDetails
   */
  transactionErrorCode?: number
}
/**
 *
 * @export
 * @enum {string}
 */
export enum OperationDirection {
  IN = 0,
  OUT = 1,
  INNER = 2,
}

/**
 *
 * @export
 * @interface OperationResponse
 */
export interface OperationResponse {
  /**
   * Уникальный номер операции в ПЦ ЭК
   * @type {string}
   * @memberof OperationResponse
   */
  mdOrder?: string
  /**
   *
   * @type {OperationStatusType}
   * @memberof OperationResponse
   */
  state?: OperationStatusType
  /**
   * Дата и время совершения операции
   * @type {string}
   * @memberof OperationResponse
   */
  date?: string
  /**
   * Номер ссылки из процессинга
   * @type {string}
   * @memberof OperationResponse
   */
  refNumber?: string
  /**
   * Код авторизации
   * @type {string}
   * @memberof OperationResponse
   */
  approvalCode?: string
  /**
   *
   * @type {OperationType}
   * @memberof OperationResponse
   */
  operationType?: OperationType
  /**
   *
   * @type {OperationDirection}
   * @memberof OperationResponse
   */
  direction?: OperationDirection
  /**
   *
   * @type {Amount}
   * @memberof OperationResponse
   */
  amount?: Amount
  /**
   *
   * @type {Binding}
   * @memberof OperationResponse
   */
  srcBinding?: Binding
  /**
   *
   * @type {Binding}
   * @memberof OperationResponse
   */
  dstBinding?: Binding
  /**
   *
   * @type {TransferType}
   * @memberof OperationResponse
   */
  transferType?: TransferType
  /**
   *
   * @type {TransferOnDemandData}
   * @memberof OperationResponse
   */
  transferOnDemandData?: TransferOnDemandData
  /**
   *
   * @type {OperationService}
   * @memberof OperationResponse
   */
  service?: OperationService
  /**
   * Пользовательский комментарий для операции
   * @type {string}
   * @memberof OperationResponse
   */
  comment?: string
  /**
   * Количество бонусных баллов, начисленных за операцию (кэшбэк операции).
   * @type {number}
   * @memberof OperationResponse
   */
  bonusPoints?: number
  /**
   *
   * @type {OperationConfirmationType}
   * @memberof OperationResponse
   */
  confirmationType?: OperationConfirmationType
  /**
   * Дата и время, до которых операция может быть подтверждена пользователем.
   * @type {string}
   * @memberof OperationResponse
   */
  otpExpiresAt?: string
  /**
   * Параметр для проведения процедуры 3DSecure  Присутствует если confirmationType= FINISH_3DS и означает, что карта вовлечена в 3DSecure
   * @type {string}
   * @memberof OperationResponse
   */
  paReq?: string
  /**
   * URL-адрес банка эмитента (сервер ACS), на который клиент должен быть перенаправлен.
   * @type {string}
   * @memberof OperationResponse
   */
  acsUrl?: string
  /**
   *
   * @type {string}
   * @memberof OperationResponse
   */
  merchantOrderId?: string
  /**
   * One time token after payment by anonymous_user_id returns in getPaymentStatus.do (for using in createCardBindingAfterPayment on authorized user)
   * @type {string}
   * @memberof OperationResponse
   */
  bindingCreationToken?: string
  /**
   *
   * @type {ForeignTransactionData}
   * @memberof OperationResponse
   */
  foreignTransactionData?: ForeignTransactionData
  /**
   *
   * @type {number}
   * @memberof OperationResponse
   */
  transactionErrorCode?: number
  /**
   *
   * @type {boolean}
   * @memberof OperationResponse
   */
  is3dsPerformed?: boolean
  /**
   *
   * @type {string}
   * @memberof OperationResponse
   */
  masterpassOperationId?: string
  /**
   *
   * @type {string}
   * @memberof OperationResponse
   */
  operationPartnerName?: string
  /**
   *
   * @type {SbpInfo}
   * @memberof OperationResponse
   */
  sbpInfo?: SbpInfo
  /**
   * Уникальный идентификатор транзакции 3DS 2.0. Обязателен при  !:OperationConfirmationType.FINISH_3DS2 или !:BindingConfirmationType.FINISH_3DS2.
   * @type {string}
   * @memberof OperationResponse
   */
  threeDsServerTransId?: string
  /**
   * URL 3D Secure метода ACS-сервера эмитента.
   * @type {string}
   * @memberof OperationResponse
   */
  threeDsMethodUrl?: string
  /**
   * BASE-64 данные для 3D Secure метода.
   * @type {string}
   * @memberof OperationResponse
   */
  threeDsMethodData?: string
  /**
   * Данные запроса аутентификации у ACS эмитента. Challenge flow.
   * @type {string}
   * @memberof OperationResponse
   */
  challengeRequest?: string
}
/**
 *
 * @export
 * @interface OperationService
 */
export interface OperationService {
  /**
   *
   * @type {string}
   * @memberof OperationService
   */
  serviceId?: string
  /**
   *
   * @type {string}
   * @memberof OperationService
   */
  serviceName?: string
  /**
   *
   * @type {string}
   * @memberof OperationService
   */
  serviceCategoryType?: string
  /**
   *
   * @type {string}
   * @memberof OperationService
   */
  serviceCategoryName?: string
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof OperationService
   */
  serviceParams?: { [key: string]: string }
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof OperationService
   */
  receiptParams?: { [key: string]: string }
}
/**
 *
 * @export
 * @enum {string}
 */
export enum OperationStatusType {
  CREATED = 0,
  APPROVED = 1,
  DEPOSITED = 2,
  REVERSED = 3,
  REFUNDED = 4,
  WAITING_CONFIRMATION = 5,
  DECLINED = 6,
  IN_PROGRESS = 7,
  VOID = 8,
}

/**
 *
 * @export
 * @enum {string}
 */
export enum OperationType {
  PAYMENT = 0,
  TRANSFER = 1,
  PURCHASE = 2,
  TOP_UP = 3,
  TRANSFER_ON_DEMAND = 4,
  P2P_CREDIT = 5,
  P2P_DEBET = 6,
  PMK_PAYMENT = 7,
  REFILL = 8,
  TRANSFER_REQ = 9,
}

/**
 *
 * @export
 * @enum {string}
 */
export enum ParameterTypeEnum {
  Unknown = 0,
  StringField = 1,
  NumberField = 2,
  EmailField = 3,
  DateField = 4,
  DateMonthField = 5,
  DateTimeField = 6,
  CheckBox = 7,
  PhoneField = 8,
  PasswordField = 9,
  ComboBox = 10,
  Amount = 11,
  PanField = 12,
  HybridField = 13,
}

/**
 *
 * @export
 * @interface PartyInfo
 */
export interface PartyInfo {
  /**
   *
   * @type {string}
   * @memberof PartyInfo
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof PartyInfo
   */
  kpp?: string
  /**
   *
   * @type {string}
   * @memberof PartyInfo
   */
  inn?: string
}
/**
 *
 * @export
 * @interface PaymentDetails
 */
export interface PaymentDetails {
  /**
   *
   * @type {Service}
   * @memberof PaymentDetails
   */
  service?: Service
  /**
   *
   * @type {string}
   * @memberof PaymentDetails
   */
  orderNumber?: string
  /**
   *
   * @type {boolean}
   * @memberof PaymentDetails
   */
  recurring?: boolean
  /**
   *
   * @type {Protocol}
   * @memberof PaymentDetails
   */
  protocol?: Protocol
  /**
   *
   * @type {SamsungPayAmount}
   * @memberof PaymentDetails
   */
  amount?: SamsungPayAmount
  /**
   *
   * @type {Merchant}
   * @memberof PaymentDetails
   */
  merchant?: Merchant
  /**
   *
   * @type {Array<string>}
   * @memberof PaymentDetails
   */
  allowedBrands?: Array<string>
}
/**
 * Запрос на выполнение платежа
 * @export
 * @interface PaymentRequest
 */
export interface PaymentRequest {
  /**
   * Уникальный идентификатор пользователя
   * @type {string}
   * @memberof PaymentRequest
   */
  userId?: string
  /**
   * Уникальный номер операции в ПЦ
   * @type {string}
   * @memberof PaymentRequest
   */
  mdOrder?: string
  /**
   * Уникальный идентификатор продукта клиента
   * @type {string}
   * @memberof PaymentRequest
   */
  bindingId?: string
  /**
   * Номер карты
   * @type {string}
   * @memberof PaymentRequest
   */
  pan?: string
  /**
   * Год и месяц действия карты  Формат – YYYYMM
   * @type {string}
   * @memberof PaymentRequest
   */
  expiry?: string
  /**
   * Имя держателя карты
   * @type {string}
   * @memberof PaymentRequest
   */
  cardholderName?: string
  /**
   * СVC-код
   * @type {string}
   * @memberof PaymentRequest
   */
  cvc?: string
  /**
   * Уникальный идентификатор поставщика
   * @type {string}
   * @memberof PaymentRequest
   */
  serviceId?: string
  /**
   * Идентификатор аггрегатора
   * @type {string}
   * @memberof PaymentRequest
   */
  aggregatorId?: string
  /**
   * Пользовательский комментарий для операции
   * @type {string}
   * @memberof PaymentRequest
   */
  comment?: string
  /**
   * Сумма заказа
   * @type {number}
   * @memberof PaymentRequest
   */
  amount?: number
  /**
   *
   * @type {Currency}
   * @memberof PaymentRequest
   */
  currency?: Currency
  /**
   * Атрибуты конкретного поставщика.
   * @type {{ [key: string]: string; }}
   * @memberof PaymentRequest
   */
  serviceParams?: { [key: string]: string }
  /**
   *
   * @type {string}
   * @memberof PaymentRequest
   */
  googlePayTokenData?: string
  /**
   *
   * @type {string}
   * @memberof PaymentRequest
   */
  applePayTokenData?: string
  /**
   *
   * @type {string}
   * @memberof PaymentRequest
   */
  samsungPayTokenData?: string
  /**
   * Идентификатор операции в MasterPass
   * @type {string}
   * @memberof PaymentRequest
   */
  masterpassOperationId?: string
  /**
   * Идентификатор запроса для Group-IB
   * @type {string}
   * @memberof PaymentRequest
   */
  fhpRequestId?: string
  /**
   * Идентификатор сессии для Group-IB
   * @type {string}
   * @memberof PaymentRequest
   */
  fhpSessionId?: string
}
/**
 *
 * @export
 * @interface PaymentToPhoneServiceInfo
 */
export interface PaymentToPhoneServiceInfo {
  /**
   *
   * @type {string}
   * @memberof PaymentToPhoneServiceInfo
   */
  parameterName?: string
  /**
   *
   * @type {string}
   * @memberof PaymentToPhoneServiceInfo
   */
  serviceId?: string
  /**
   *
   * @type {string}
   * @memberof PaymentToPhoneServiceInfo
   */
  fiscalPhoneParameterName?: string
  /**
   *
   * @type {string}
   * @memberof PaymentToPhoneServiceInfo
   */
  fiscalPhone?: string
  /**
   *
   * @type {string}
   * @memberof PaymentToPhoneServiceInfo
   */
  fiscalEmailParameterName?: string
  /**
   *
   * @type {string}
   * @memberof PaymentToPhoneServiceInfo
   */
  fiscalEmail?: string
}
/**
 *
 * @export
 * @interface Promotion
 */
export interface Promotion {
  /**
   *
   * @type {Array<PromotionCategory>}
   * @memberof Promotion
   */
  categories?: Array<PromotionCategory>
  /**
   *
   * @type {string}
   * @memberof Promotion
   */
  description?: string
  /**
   *
   * @type {string}
   * @memberof Promotion
   */
  link?: string
  /**
   *
   * @type {string}
   * @memberof Promotion
   */
  image?: string
  /**
   *
   * @type {string}
   * @memberof Promotion
   */
  buttonName?: string
  /**
   *
   * @type {string}
   * @memberof Promotion
   */
  lastModified?: string
  /**
   *
   * @type {boolean}
   * @memberof Promotion
   */
  isNew?: boolean
  /**
   *
   * @type {number}
   * @memberof Promotion
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof Promotion
   */
  title?: string
}
/**
 *
 * @export
 * @interface PromotionCategory
 */
export interface PromotionCategory {
  /**
   *
   * @type {number}
   * @memberof PromotionCategory
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof PromotionCategory
   */
  title?: string
}
/**
 *
 * @export
 * @interface PromotionsResponse
 */
export interface PromotionsResponse {
  /**
   *
   * @type {string}
   * @memberof PromotionsResponse
   */
  title?: string
  /**
   *
   * @type {string}
   * @memberof PromotionsResponse
   */
  lastVisit?: string
  /**
   *
   * @type {Array<PromotionCategory>}
   * @memberof PromotionsResponse
   */
  filterCategories?: Array<PromotionCategory>
  /**
   *
   * @type {Array<Promotion>}
   * @memberof PromotionsResponse
   */
  promotions?: Array<Promotion>
}
/**
 *
 * @export
 * @interface Protocol
 */
export interface Protocol {
  /**
   *
   * @type {string}
   * @memberof Protocol
   */
  type?: string
  /**
   *
   * @type {string}
   * @memberof Protocol
   */
  version?: string
}
/**
 *
 * @export
 * @interface ProviderParams
 */
export interface ProviderParams {
  /**
   * Связан ли с л/счетом получателя более чем один номер телефона.
   * @type {boolean}
   * @memberof ProviderParams
   */
  multiAccount?: boolean
  /**
   * Доступна ли акция \"10% скидка\" за подключение АП по порогу на заданный номер получателя.
   * @type {boolean}
   * @memberof ProviderParams
   */
  discountApBalanceAvailable?: boolean
  /**
   * Доступна ли акция \"10% скидка\" за подключение АП по расписанию на заданный номер получателя.
   * @type {boolean}
   * @memberof ProviderParams
   */
  discountApScheduleAvailable?: boolean
}
/**
 * Информация о счете
 * @export
 * @interface RecomendationAmountInfo
 */
export interface RecomendationAmountInfo {
  /**
   * Текст подсказки  ///
   * @type {string}
   * @memberof RecomendationAmountInfo
   */
  hint?: string
  /**
   * Величина
   * @type {number}
   * @memberof RecomendationAmountInfo
   */
  amount?: number
  /**
   *
   * @type {Currency}
   * @memberof RecomendationAmountInfo
   */
  cur?: Currency
}
/**
 *
 * @export
 * @interface Region
 */
export interface Region {
  /**
   *
   * @type {string}
   * @memberof Region
   */
  countryCode?: string
  /**
   *
   * @type {string}
   * @memberof Region
   */
  countryName?: string
  /**
   *
   * @type {string}
   * @memberof Region
   */
  regionCode?: string
  /**
   *
   * @type {string}
   * @memberof Region
   */
  regionName?: string
  /**
   *
   * @type {string}
   * @memberof Region
   */
  timeZone?: string
  /**
   *
   * @type {string}
   * @memberof Region
   */
  regionCentre?: string
  /**
   *
   * @type {string}
   * @memberof Region
   */
  regionCentreCode?: string
  /**
   *
   * @type {string}
   * @memberof Region
   */
  macroregion?: string
  /**
   *
   * @type {string}
   * @memberof Region
   */
  macroregionCode?: string
}
/**
 * Тип перерасчета суммы\\срока кредита  LESS_TERM - Уменьшение срока кредита  LESS_PAYMENT - Уменьшение ежемесячного платежа  ALL - Оба варианта возможны   CANNOT - перерасчет не возможен
 * @export
 * @enum {string}
 */
export enum RepaymentTypeEnum {
  UNKNOWN = 0,
  LESS_TERM = 1,
  LESS_PAYMENT = 2,
  ALL = 3,
  CANNOT = 4,
}

/**
 *
 * @export
 * @enum {string}
 */
export enum ResponseStatus {
  SUCCESS = 0,
  ERROR = 1,
}

/**
 *
 * @export
 * @interface SamsungPayAmount
 */
export interface SamsungPayAmount {
  /**
   *
   * @type {string}
   * @memberof SamsungPayAmount
   */
  option?: string
  /**
   *
   * @type {string}
   * @memberof SamsungPayAmount
   */
  currency?: string
  /**
   *
   * @type {number}
   * @memberof SamsungPayAmount
   */
  total?: number
}
/**
 *
 * @export
 * @interface SbpInfo
 */
export interface SbpInfo {
  /**
   *
   * @type {string}
   * @memberof SbpInfo
   */
  orderId?: string
  /**
   *
   * @type {string}
   * @memberof SbpInfo
   */
  sbpOperId?: string
  /**
   *
   * @type {string}
   * @memberof SbpInfo
   */
  recipientPAM?: string
  /**
   *
   * @type {string}
   * @memberof SbpInfo
   */
  recipientPhone?: string
  /**
   *
   * @type {string}
   * @memberof SbpInfo
   */
  userMessage?: string
  /**
   *
   * @type {string}
   * @memberof SbpInfo
   */
  bankId?: string
  /**
   *
   * @type {string}
   * @memberof SbpInfo
   */
  bankName?: string
  /**
   *
   * @type {string}
   * @memberof SbpInfo
   */
  accSuffix?: string
}
/**
 * Расписание автоплатежей
 * @export
 * @interface Schedule
 */
export interface Schedule {
  /**
   * Время срабатывания расписания
   * @type {string}
   * @memberof Schedule
   */
  time?: string
  /**
   * Временная зона, относительно которой указано время
   * @type {string}
   * @memberof Schedule
   */
  timeZone?: string
  /**
   *
   * @type {ScheduleType}
   * @memberof Schedule
   */
  scheduleType?: ScheduleType
  /**
   * Дата начала действия автоплатежа
   * @type {string}
   * @memberof Schedule
   */
  date?: string
  /**
   * Период выполнения платежей в днях. Значения от 1 до 180.
   * @type {number}
   * @memberof Schedule
   */
  period?: number
  /**
   * День недели выполнения платежа
   * @type {number}
   * @memberof Schedule
   */
  dayOfWeek?: number
  /**
   * Номер дня выполнения платежа в месяце
   * @type {number}
   * @memberof Schedule
   */
  dayOfMonth?: number
}
/**
 * Набор параметров, описывающих расписание Автоплатежа
 * @export
 * @interface ScheduleConditions
 */
export interface ScheduleConditions {
  /**
   * Номер дня выполнения платежа в месяце
   * @type {number}
   * @memberof ScheduleConditions
   */
  dayOfMonth?: number
  /**
   * День недели выполнения платежа
   * @type {number}
   * @memberof ScheduleConditions
   */
  dayOfWeek?: number
  /**
   * Период выполнения платежей в днях. Значения от 1 до 180.
   * @type {number}
   * @memberof ScheduleConditions
   */
  recurrencePeriod?: number
  /**
   * Дата выполнения платежа – для расписания в фиксированную дату
   * @type {string}
   * @memberof ScheduleConditions
   */
  fixedDate?: string
  /**
   * Время срабатывания расписания
   * @type {string}
   * @memberof ScheduleConditions
   */
  actuationTime?: string
  /**
   * Временная зона, относительно которой указано время
   * @type {string}
   * @memberof ScheduleConditions
   */
  timeZone?: string
  /**
   * Признак включенного/выключенного СМС-уведомления о предстоящем АП
   * @type {number}
   * @memberof ScheduleConditions
   */
  paymentPreNotificationPeriod?: number
  /**
   *
   * @type {string}
   * @memberof ScheduleConditions
   */
  upcomingPaymentDate?: string
}
/**
 *
 * @export
 * @enum {string}
 */
export enum ScheduleType {
  DATE = 0,
  PERIOD = 1,
  DOW = 2,
  DOM = 3,
  DAYLY = 4,
  UNKNOWN = -1,
}

/**
 * Результат поиска ТСП
 * @export
 * @interface SearchServiceResult
 */
export interface SearchServiceResult {
  /**
   * Уникальный идентификатор поставщика в Платформе
   * @type {string}
   * @memberof SearchServiceResult
   */
  serviceId?: string
  /**
   * Наименование поставщика
   * @type {string}
   * @memberof SearchServiceResult
   */
  name?: string
  /**
   * Адрес файла с картинкой для поставщика
   * @type {string}
   * @memberof SearchServiceResult
   */
  iconUrl?: string
  /**
   * Имя категории
   * @type {string}
   * @memberof SearchServiceResult
   */
  category?: string
  /**
   * Идентификатор категории
   * @type {string}
   * @memberof SearchServiceResult
   */
  categoryId?: string
}
/**
 * Запрос на отсылку результатов операции
 * @export
 * @interface SendReceiptRequest
 */
export interface SendReceiptRequest {
  /**
   * Код транзакции
   * @type {string}
   * @memberof SendReceiptRequest
   */
  mdOrder?: string
  /**
   * refNumber транзакци
   * @type {string}
   * @memberof SendReceiptRequest
   */
  refNumber?: string
  /**
   * Почтовый адрес получателя
   * @type {string}
   * @memberof SendReceiptRequest
   */
  email?: string
  /**
   * Номер телефона пользователя(если знаем)
   * @type {string}
   * @memberof SendReceiptRequest
   */
  phone?: string
}
/**
 * Результат отправки операции по почте
 * @export
 * @interface SendReceiptResult
 */
export interface SendReceiptResult {
  /**
   * Признак успешной отправки результатов операции
   * @type {boolean}
   * @memberof SendReceiptResult
   */
  success?: boolean
  /**
   * Сообщение о результате отправки сообщения
   * @type {string}
   * @memberof SendReceiptResult
   */
  message?: string
}
/**
 *
 * @export
 * @interface Service
 */
export interface Service {
  /**
   *
   * @type {string}
   * @memberof Service
   */
  id?: string
}
/**
 * Данные о максимальных и минимальных лимитах платежа по поставщику, используемые для контроля ввода данных
 * @export
 * @interface ServiceAmountRange
 */
export interface ServiceAmountRange {
  /**
   * Минимальная сумма платежа без комиссии в коzпейках
   * @type {number}
   * @memberof ServiceAmountRange
   */
  min?: number
  /**
   * Максимальная сумма платежа без комиссии в копейках
   * @type {number}
   * @memberof ServiceAmountRange
   */
  max?: number
}
/**
 *
 * @export
 * @interface ServiceCategory
 */
export interface ServiceCategory {
  /**
   * Отображаемое имя для категории поставщиков
   * @type {string}
   * @memberof ServiceCategory
   */
  title?: string
  /**
   * Наименование категории поставщиков
   * @type {string}
   * @memberof ServiceCategory
   */
  name?: string
  /**
   * Адрес файла с картинкой для категории
   * @type {string}
   * @memberof ServiceCategory
   */
  iconUrl?: string
  /**
   * Количество поставщиков, отображаемых на странице выбора поставщика без обращения к перечню всех поставщиков
   * @type {number}
   * @memberof ServiceCategory
   */
  providersCount?: number
}
/**
 * Данные о категории поставщиков
 * @export
 * @interface ServiceCategoryInfo
 */
export interface ServiceCategoryInfo {
  /**
   * Отображаемое имя для категории поставщиков
   * @type {string}
   * @memberof ServiceCategoryInfo
   */
  title?: string
  /**
   * Наименование категории поставщиков
   * @type {string}
   * @memberof ServiceCategoryInfo
   */
  name?: string
  /**
   * Адрес файла с картинкой для категории
   * @type {string}
   * @memberof ServiceCategoryInfo
   */
  iconUrl?: string
  /**
   * Количество поставщиков, отображаемых на странице выбора поставщика без обращения к перечню всех поставщиков
   * @type {number}
   * @memberof ServiceCategoryInfo
   */
  providersCount?: number
  /**
   * Данные о поставщиках
   * @type {number}
   * @memberof ServiceCategoryInfo
   */
  bonusPercent?: number
  /**
   *
   * @type {number}
   * @memberof ServiceCategoryInfo
   */
  sortOrder?: number
}
/**
 * Параметры ТСП
 * @export
 * @interface ServiceInfo
 */
export interface ServiceInfo {
  /**
   * Признак доступности создания автоплатежа
   * @type {boolean}
   * @memberof ServiceInfo
   */
  autopaymentDisabled?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ServiceInfo
   */
  searchInvoices?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ServiceInfo
   */
  creditAllowed?: boolean
  /**
   * Номер категории МТС у ТСП
   * @type {string}
   * @memberof ServiceInfo
   */
  providerMtsCategoryId?: string
  /**
   *
   * @type {ServiceCategory}
   * @memberof ServiceInfo
   */
  category?: ServiceCategory
  /**
   *
   * @type {ServiceAmountRange}
   * @memberof ServiceInfo
   */
  amount?: ServiceAmountRange
  /**
   * ИНН поставщика
   * @type {string}
   * @memberof ServiceInfo
   */
  inn?: string
  /**
   * Данные о параметрах, необходимых для выполнения платежа в пользу поставщика
   * @type {Array<ServiceParameter>}
   * @memberof ServiceInfo
   */
  parameters?: Array<ServiceParameter>
  /**
   * Данные о параметрах, для отображения на чеке
   * @type {Array<ServiceParameterSimple>}
   * @memberof ServiceInfo
   */
  receiptParameters?: Array<ServiceParameterSimple>
  /**
   * Перечень типов платежных инструментов, которые можно использовать для оплаты данной услуги
   * @type {Array<BindingType>}
   * @memberof ServiceInfo
   */
  allowedBindingTypes?: Array<BindingType>
  /**
   * Признак нулевой комиссии
   * @type {boolean}
   * @memberof ServiceInfo
   */
  isZeroCommision?: boolean
  /**
   * Порядок сортировки на стартовой странице
   * @type {number}
   * @memberof ServiceInfo
   */
  displayOnStartOrder?: number
  /**
   * Уникальный идентификатор поставщика в Платформе
   * @type {string}
   * @memberof ServiceInfo
   */
  serviceId?: string
  /**
   * Наименование поставщика
   * @type {string}
   * @memberof ServiceInfo
   */
  name?: string
  /**
   * Наименование ЮЛ
   * @type {string}
   * @memberof ServiceInfo
   */
  legal?: string
  /**
   * Адрес файла с картинкой для поставщика
   * @type {string}
   * @memberof ServiceInfo
   */
  iconUrl?: string
  /**
   * Признак скрытого ТСП. не отображается в каталоге для пользователя
   * @type {boolean}
   * @memberof ServiceInfo
   */
  isHidden?: boolean
  /**
   * Порядок сортировки
   * @type {number}
   * @memberof ServiceInfo
   */
  sortOrder?: number
}
/**
 * Данные о параметрах, необходимых для выполнения платежа в пользу поставщика
 * @export
 * @interface ServiceParameter
 */
export interface ServiceParameter {
  /**
   *
   * @type {ParameterTypeEnum}
   * @memberof ServiceParameter
   */
  type?: ParameterTypeEnum
  /**
   * Подсказка для отображения пользователю
   * @type {string}
   * @memberof ServiceParameter
   */
  userHint?: string
  /**
   * Признак скрытости параметра
   * @type {boolean}
   * @memberof ServiceParameter
   */
  isHidden?: boolean
  /**
   * Параметр для получения фискального чека
   * @type {boolean}
   * @memberof ServiceParameter
   */
  forFiscal?: boolean
  /**
   * Максимальная длина параметра
   * @type {number}
   * @memberof ServiceParameter
   */
  maxLength?: number
  /**
   * Значение по умолчанию. Может быть пустым.
   * @type {string}
   * @memberof ServiceParameter
   */
  defaultValue?: string
  /**
   * Маска ввода. Может быть пустым.
   * @type {string}
   * @memberof ServiceParameter
   */
  mask?: string
  /**
   * Справочник для полей тима COMBOBOX
   * @type {{ [key: string]: string; }}
   * @memberof ServiceParameter
   */
  dictionary?: { [key: string]: string }
  /**
   * Правила валидации введенного пользователем значения параметра на основе регулярных выражений
   * @type {string}
   * @memberof ServiceParameter
   */
  regexp?: string
  /**
   * Число, задает порядок отображения параметра на витрине
   * @type {number}
   * @memberof ServiceParameter
   */
  sortOrder?: number
  /**
   * Признак вывода параметра на витрину в режиме \"только для чтения\".
   * @type {boolean}
   * @memberof ServiceParameter
   */
  readOnly?: boolean
  /**
   * Признак обязательности заполнения параметра клиентом на витрине
   * @type {boolean}
   * @memberof ServiceParameter
   */
  required?: boolean
  /**
   * Отображаемое имя параметра для выполнения платежа
   * @type {string}
   * @memberof ServiceParameter
   */
  title?: string
  /**
   * Наименование параметра для выполнения платежа
   * @type {string}
   * @memberof ServiceParameter
   */
  name?: string
  /**
   * Описание параметра платежа . Может быть пустым.
   * @type {string}
   * @memberof ServiceParameter
   */
  description?: string
}
/**
 * Данные о параметрах ТСП
 * @export
 * @interface ServiceParameterSimple
 */
export interface ServiceParameterSimple {
  /**
   * Отображаемое имя параметра для выполнения платежа
   * @type {string}
   * @memberof ServiceParameterSimple
   */
  title?: string
  /**
   * Наименование параметра для выполнения платежа
   * @type {string}
   * @memberof ServiceParameterSimple
   */
  name?: string
  /**
   * Описание параметра платежа . Может быть пустым.
   * @type {string}
   * @memberof ServiceParameterSimple
   */
  description?: string
}
/**
 * Конфигурация SPA
 * @export
 * @interface SpaConfig
 */
export interface SpaConfig {
  /**
   * Таймаут активности пользователя
   * @type {number}
   * @memberof SpaConfig
   */
  authExpireTimeoutMin?: number
  /**
   * Ссылка выхода приложения ASP.NET для вызова с редиректом
   * @type {string}
   * @memberof SpaConfig
   */
  signOutUrl?: string
  /**
   * Ссылка выхода приложения ASP.NET для AJAX вызова
   * @type {string}
   * @memberof SpaConfig
   */
  silentSignOutUrl?: string
  /**
   *
   * @type {SsoConfig}
   * @memberof SpaConfig
   */
  ssoConfig?: SsoConfig
}
/**
 * Конфигурация SSO
 * @export
 * @interface SsoConfig
 */
export interface SsoConfig {
  /**
   * ID клиента SSO
   * @type {string}
   * @memberof SsoConfig
   */
  clientId?: string
  /**
   * Базовая url SSO
   * @type {string}
   * @memberof SsoConfig
   */
  ssoBaseUrl?: string
  /**
   * Базовая url SSO proxy
   * @type {string}
   * @memberof SsoConfig
   */
  proxyBaseUrl?: string
  /**
   * Относительная ссылка proxy - путь на SSO Sign In
   * @type {string}
   * @memberof SsoConfig
   */
  signInPath?: string
  /**
   * Относительная ссылка proxy - путь выхода и обнуления токена
   * @type {string}
   * @memberof SsoConfig
   */
  signOutPath?: string
}
/**
 *
 * @export
 * @interface SuggestBankInfo
 */
export interface SuggestBankInfo {
  /**
   *
   * @type {string}
   * @memberof SuggestBankInfo
   */
  bic?: string
  /**
   *
   * @type {string}
   * @memberof SuggestBankInfo
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof SuggestBankInfo
   */
  corrAccount?: string
  /**
   *
   * @type {string}
   * @memberof SuggestBankInfo
   */
  icon?: string
}
/**
 *
 * @export
 * @interface SuppressDateResult
 */
export interface SuppressDateResult {
  /**
   *
   * @type {number}
   * @memberof SuppressDateResult
   */
  errorCode?: number
  /**
   *
   * @type {boolean}
   * @memberof SuppressDateResult
   */
  suppressed?: boolean
  /**
   *
   * @type {string}
   * @memberof SuppressDateResult
   */
  date?: string
}
/**
 *
 * @export
 * @interface SuspendInfo
 */
export interface SuspendInfo {
  /**
   * Причина приостановления (блокировки) автоплатежа.
   * @type {string}
   * @memberof SuspendInfo
   */
  suspensionReason: string
  /**
   * Дата, после которой приостановленный Автоплатеж будет автоматически возобновлен.
   * @type {string}
   * @memberof SuspendInfo
   */
  suspensionEndDate?: string
}
/**
 *
 * @export
 * @enum {string}
 */
export enum TermsUnit {
  Unknown = 0,
  Days = 1,
  Weeks = 2,
  Months = 3,
  Years = 4,
  Indefinite = 5,
}

/**
 *
 * @export
 * @interface ThreeDsProceedBindModel
 */
export interface ThreeDsProceedBindModel {
  /**
   *
   * @type {string}
   * @memberof ThreeDsProceedBindModel
   */
  type?: string
  /**
   *
   * @type {string}
   * @memberof ThreeDsProceedBindModel
   */
  mdOrder?: string
  /**
   *
   * @type {string}
   * @memberof ThreeDsProceedBindModel
   */
  serviceId?: string
  /**
   *
   * @type {string}
   * @memberof ThreeDsProceedBindModel
   */
  bindingId?: string
  /**
   *
   * @type {string}
   * @memberof ThreeDsProceedBindModel
   */
  fiscalPhone?: string
  /**
   *
   * @type {string}
   * @memberof ThreeDsProceedBindModel
   */
  fiscalEmail?: string
  /**
   *
   * @type {string}
   * @memberof ThreeDsProceedBindModel
   */
  returnUrl?: string
  /**
   *
   * @type {string}
   * @memberof ThreeDsProceedBindModel
   */
  repeatUrl?: string
  /**
   *
   * @type {ThreeDsUserInfo}
   * @memberof ThreeDsProceedBindModel
   */
  userInfo: ThreeDsUserInfo
  /**
   *
   * @type {boolean}
   * @memberof ThreeDsProceedBindModel
   */
  mgts?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ThreeDsProceedBindModel
   */
  mpBind?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ThreeDsProceedBindModel
   */
  createAp?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ThreeDsProceedBindModel
   */
  isWebView?: boolean
  /**
   *
   * @type {VerifiedOperationType}
   * @memberof ThreeDsProceedBindModel
   */
  operationType?: VerifiedOperationType
}
/**
 *
 * @export
 * @interface ThreeDsProceedDto
 */
export interface ThreeDsProceedDto {
  /**
   * Уникальный номер операции в ПЦ ЭК, полученный в ответе на payment.
   * @type {string}
   * @memberof ThreeDsProceedDto
   */
  mdOrder: string
  /**
   * Полный URL-сайта ТСП.
   * @type {string}
   * @memberof ThreeDsProceedDto
   */
  threeDsRequestorUrl: string
  /**
   * Содержимое HTTP-заголовка.
   * @type {string}
   * @memberof ThreeDsProceedDto
   */
  browserAcceptHeader: string
  /**
   * IP-адрес браузера клиента.
   * @type {string}
   * @memberof ThreeDsProceedDto
   */
  browserIP: string
  /**
   * Признак доступности JAVA в браузере клиента, необязательный, если JavaScript недоступен.
   * @type {boolean}
   * @memberof ThreeDsProceedDto
   */
  browserJavaEnabled?: boolean
  /**
   * Признак доступности JavaScript в браузере клиента.
   * @type {boolean}
   * @memberof ThreeDsProceedDto
   */
  browserJavascriptEnabled: boolean
  /**
   * Язык браузера клиента (свойство navigator.language).
   * @type {string}
   * @memberof ThreeDsProceedDto
   */
  browserLanguage: string
  /**
   * Глубина цвета в браузере клиента: 1, 4, 8, 15, 16, 24, 32, 48.  Необязательно, если JavaScript недоступен.
   * @type {string}
   * @memberof ThreeDsProceedDto
   */
  browserColorDepth?: string
  /**
   * Разрешение экрана по высоте в пикселях.
   * @type {string}
   * @memberof ThreeDsProceedDto
   */
  browserScreenHeight?: string
  /**
   * Разрешение экрана по ширине в пикселях.
   * @type {string}
   * @memberof ThreeDsProceedDto
   */
  browserScreenWidth?: string
  /**
   * Тайм-зона браузера. Разница во времени между UTC и локальным временем клиента в минутах.
   * @type {string}
   * @memberof ThreeDsProceedDto
   */
  browserTZ?: string
  /**
   * User-Agent браузера, содержимое HTTP-заголовка user-agent.
   * @type {string}
   * @memberof ThreeDsProceedDto
   */
  browserUserAgent: string
  /**
   * Fully qualified URL of the system that receives the CRes message or Error Message.
   * @type {string}
   * @memberof ThreeDsProceedDto
   */
  notificationUrl: string
  /**
   * Размер окна для запроса паролей эмитентом
   * @type {string}
   * @memberof ThreeDsProceedDto
   */
  challengeWindowSize?: string
}
/**
 *
 * @export
 * @interface ThreeDsProceedPayModel
 */
export interface ThreeDsProceedPayModel {
  /**
   *
   * @type {ThreeDsUserInfo}
   * @memberof ThreeDsProceedPayModel
   */
  userInfo: ThreeDsUserInfo
  /**
   *
   * @type {boolean}
   * @memberof ThreeDsProceedPayModel
   */
  doNotShowCheck?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ThreeDsProceedPayModel
   */
  doNotShowCrossButton?: boolean
  /**
   *
   * @type {string}
   * @memberof ThreeDsProceedPayModel
   */
  returnUrl?: string
  /**
   *
   * @type {string}
   * @memberof ThreeDsProceedPayModel
   */
  type?: string
  /**
   *
   * @type {boolean}
   * @memberof ThreeDsProceedPayModel
   */
  mgts?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ThreeDsProceedPayModel
   */
  mpBind?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ThreeDsProceedPayModel
   */
  createAp?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ThreeDsProceedPayModel
   */
  bindCard?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ThreeDsProceedPayModel
   */
  isWebView?: boolean
  /**
   *
   * @type {string}
   * @memberof ThreeDsProceedPayModel
   */
  referer?: string
  /**
   *
   * @type {boolean}
   * @memberof ThreeDsProceedPayModel
   */
  createTemplate?: boolean
  /**
   *
   * @type {VerifiedOperationType}
   * @memberof ThreeDsProceedPayModel
   */
  operationType?: VerifiedOperationType
  /**
   *
   * @type {string}
   * @memberof ThreeDsProceedPayModel
   */
  mdOrder?: string
  /**
   *
   * @type {string}
   * @memberof ThreeDsProceedPayModel
   */
  verificationSignValue?: string
}
/**
 *
 * @export
 * @interface ThreeDsUserInfo
 */
export interface ThreeDsUserInfo {
  /**
   *
   * @type {string}
   * @memberof ThreeDsUserInfo
   */
  mdOrder: string
  /**
   *
   * @type {string}
   * @memberof ThreeDsUserInfo
   */
  threeDsRequestorUrl: string
  /**
   *
   * @type {boolean}
   * @memberof ThreeDsUserInfo
   */
  browserJavaEnabled?: boolean
  /**
   *
   * @type {UserJavaScriptInfo}
   * @memberof ThreeDsUserInfo
   */
  browserJavascriptInfo?: UserJavaScriptInfo
  /**
   *
   * @type {string}
   * @memberof ThreeDsUserInfo
   */
  browserLanguage: string
  /**
   *
   * @type {string}
   * @memberof ThreeDsUserInfo
   */
  browserUserAgent: string
  /**
   *
   * @type {string}
   * @memberof ThreeDsUserInfo
   */
  notificationUrl: string
  /**
   *
   * @type {string}
   * @memberof ThreeDsUserInfo
   */
  challengeWindowSize?: string
}
/**
 * Набор параметров, описывающих условия работы Автоплатежа по порогу
 * @export
 * @interface ThresholdConditions
 */
export interface ThresholdConditions {
  /**
   * Порог баланса лицевого счета, после которого возникает необходимость автоплатежа
   * @type {number}
   * @memberof ThresholdConditions
   */
  balanceThreshold?: number
  /**
   * Месячный лимит на агрегированную сумму платежей
   * @type {number}
   * @memberof ThresholdConditions
   */
  monthlyPaymentsLimit?: number
}
/**
 *
 * @export
 * @interface TransferByReqSource
 */
export interface TransferByReqSource {
  /**
   *
   * @type {string}
   * @memberof TransferByReqSource
   */
  accountNumber?: string
  /**
   *
   * @type {string}
   * @memberof TransferByReqSource
   */
  hashedPAN?: string
  /**
   *
   * @type {string}
   * @memberof TransferByReqSource
   */
  bindingId?: string
}
/**
 *
 * @export
 * @interface TransferByReqTarget
 */
export interface TransferByReqTarget {
  /**
   *
   * @type {string}
   * @memberof TransferByReqTarget
   */
  accountNumber: string
  /**
   *
   * @type {string}
   * @memberof TransferByReqTarget
   */
  receiverName: string
  /**
   *
   * @type {string}
   * @memberof TransferByReqTarget
   */
  tin?: string
  /**
   *
   * @type {string}
   * @memberof TransferByReqTarget
   */
  rrc?: string
  /**
   *
   * @type {BankInfo}
   * @memberof TransferByReqTarget
   */
  bankInfo?: BankInfo
}
/**
 *
 * @export
 * @interface TransferOnDemandData
 */
export interface TransferOnDemandData {
  /**
   *
   * @type {string}
   * @memberof TransferOnDemandData
   */
  uuid?: string
  /**
   *
   * @type {string}
   * @memberof TransferOnDemandData
   */
  date?: string
  /**
   *
   * @type {string}
   * @memberof TransferOnDemandData
   */
  expiresAt?: string
  /**
   *
   * @type {TransferOnDemandStatus}
   * @memberof TransferOnDemandData
   */
  status?: TransferOnDemandStatus
  /**
   *
   * @type {string}
   * @memberof TransferOnDemandData
   */
  targetPhoneNumber?: string
  /**
   *
   * @type {string}
   * @memberof TransferOnDemandData
   */
  sourcePhoneNumber?: string
}
/**
 *
 * @export
 * @enum {string}
 */
export enum TransferOnDemandStatus {
  CREATED = 0,
  WAITING_CONFIRMATION = 1,
  FINISHED = 2,
  EXPIRED = 3,
  CANCELLED_BY_SENDER = 4,
  CANCELLED_BY_RECIPIENT = 5,
}

/**
 * Запрос на перевод
 * @export
 * @interface TransferRequest
 */
export interface TransferRequest {
  /**
   *
   * @type {TransferType}
   * @memberof TransferRequest
   */
  type?: TransferType
  /**
   * Уникальный номер операции в ПЦ
   * @type {string}
   * @memberof TransferRequest
   */
  mdOrder?: string
  /**
   * Уникальный идентификатор Платежного инструмента
   * @type {string}
   * @memberof TransferRequest
   */
  bindingId?: string
  /**
   * Номер карты, с которой осуществляется перевод
   * @type {string}
   * @memberof TransferRequest
   */
  pan?: string
  /**
   * Год и месяц действия карты, с которой осуществляется перевод
   * @type {string}
   * @memberof TransferRequest
   */
  expiry?: string
  /**
   * Имя держателя карты, с которой осуществляется перевод
   * @type {string}
   * @memberof TransferRequest
   */
  cardholderName?: string
  /**
   * СVC-код, с которой осуществляется перевод
   * @type {string}
   * @memberof TransferRequest
   */
  cvc?: string
  /**
   * Уникальный идентификатор Платежного инструмента, получателя перевода
   * @type {string}
   * @memberof TransferRequest
   */
  targetBindingId?: string
  /**
   * Номер карты, на которую осуществляется перевод
   * @type {string}
   * @memberof TransferRequest
   */
  targetPan?: string
  /**
   * токенированный TargetPan.
   * @type {string}
   * @memberof TransferRequest
   */
  tokenizedTargetPan?: string
  /**
   * Пользовательский комментарий для операции
   * @type {string}
   * @memberof TransferRequest
   */
  comment?: string
  /**
   * Сумма, которая должна быть отправлена (без учета комиссии).
   * @type {number}
   * @memberof TransferRequest
   */
  amount?: number
  /**
   * Валюта заказа
   * @type {number}
   * @memberof TransferRequest
   */
  currency?: number
  /**
   *
   * @type {PaymentToPhoneServiceInfo}
   * @memberof TransferRequest
   */
  phonePaymentInfo?: PaymentToPhoneServiceInfo
  /**
   *
   * @type {boolean}
   * @memberof TransferRequest
   */
  isExternal?: boolean
  /**
   *
   * @type {BindingType}
   * @memberof TransferRequest
   */
  targetBindingType?: BindingType
  /**
   *
   * @type {BindingType}
   * @memberof TransferRequest
   */
  bindingType?: BindingType
  /**
   *
   * @type {string}
   * @memberof TransferRequest
   */
  srcPhone?: string
  /**
   *
   * @type {string}
   * @memberof TransferRequest
   */
  dstPhone?: string
  /**
   *
   * @type {string}
   * @memberof TransferRequest
   */
  masterpassOperationId?: string
  /**
   * Идентификатор запроса для Group-IB
   * @type {string}
   * @memberof TransferRequest
   */
  fhpRequestId?: string
  /**
   * Идентификатор сессии для Group-IB
   * @type {string}
   * @memberof TransferRequest
   */
  fhpSessionId?: string
}
/**
 *
 * @export
 * @interface TransferState
 */
export interface TransferState {
  /**
   *
   * @type {string}
   * @memberof TransferState
   */
  transferId?: string
  /**
   *
   * @type {string}
   * @memberof TransferState
   */
  state?: string
  /**
   *
   * @type {string}
   * @memberof TransferState
   */
  stateDetail?: string
  /**
   *
   * @type {string}
   * @memberof TransferState
   */
  operationId?: string
  /**
   *
   * @type {string}
   * @memberof TransferState
   */
  sbpOperId?: string
}
/**
 *
 * @export
 * @interface TransferStateResponse
 */
export interface TransferStateResponse {
  /**
   *
   * @type {TransferState}
   * @memberof TransferStateResponse
   */
  state?: TransferState
  /**
   *
   * @type {number}
   * @memberof TransferStateResponse
   */
  errorCode?: number
  /**
   *
   * @type {string}
   * @memberof TransferStateResponse
   */
  errorDescription?: string
}
/**
 *
 * @export
 * @enum {string}
 */
export enum TransferType {
  BINDING_TO_BINDING = 0,
  CARD_TO_BINDING = 1,
  CARD_TO_EMONEY = 2,
  BINDING_TO_EMONEY = 3,
  BINDING_TO_CARD = 4,
  CARD_TO_CARD = 5,
  BindingToPhone = 6,
  CardToPhone = 7,
  BINDING_TO_NEW_EMONEY = 8,
  CARD_TO_NEW_EMONEY = 9,
  INT_SELF = 10,
  INT_PERSON = 11,
  EXT_PERSON = 12,
  EXT_JURIDICAL = 13,
  EXT_BUDGET = 14,
  INT_BYPHONE = 15,
  EXT_SBP = 16,
  EXT_SBP_C2B = 17,
}

/**
 *
 * @export
 * @interface UserJavaScriptInfo
 */
export interface UserJavaScriptInfo {
  /**
   *
   * @type {number}
   * @memberof UserJavaScriptInfo
   */
  browserColorDepth: number
  /**
   *
   * @type {number}
   * @memberof UserJavaScriptInfo
   */
  browserScreenHeight: number
  /**
   *
   * @type {number}
   * @memberof UserJavaScriptInfo
   */
  browserScreenWidth: number
  /**
   *
   * @type {number}
   * @memberof UserJavaScriptInfo
   */
  browserTZ: number
}
/**
 *
 * @export
 * @enum {string}
 */
export enum VatEnum {
  None = 0,
  Vat10 = 10,
  Vat18 = 18,
  Vat20 = 20,
}

/**
 *
 * @export
 * @enum {string}
 */
export enum VerifiedOperationType {
  Undefined = 0,
  Payment = 1,
  Transfer = 2,
  AddBinding = 3,
  Newpay = 4,
  NewTransfer = 5,
}

/**
 * AntiForgeryTokenApi - axios parameter creator
 * @export
 */
export const AntiForgeryTokenApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAftGet(options: any = {}): RequestArgs {
      const localVarPath = `/api/aft`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AntiForgeryTokenApi - functional programming interface
 * @export
 */
export const AntiForgeryTokenApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAftGet(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
      const localVarAxiosArgs = AntiForgeryTokenApiAxiosParamCreator(configuration).apiAftGet(options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * AntiForgeryTokenApi - factory interface
 * @export
 */
export const AntiForgeryTokenApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAftGet(options?: any): AxiosPromise<string> {
      return AntiForgeryTokenApiFp(configuration).apiAftGet(options)(axios, basePath)
    },
  }
}

/**
 * AntiForgeryTokenApi - object-oriented interface
 * @export
 * @class AntiForgeryTokenApi
 * @extends {BaseAPI}
 */
export class AntiForgeryTokenApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AntiForgeryTokenApi
   */
  public apiAftGet(options?: any) {
    return AntiForgeryTokenApiFp(this.configuration).apiAftGet(options)(this.axios, this.basePath)
  }
}

/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSilentSignOutPost(options: any = {}): RequestArgs {
      const localVarPath = `/api/silentSignOut`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSilentSignOutPost(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = AuthApiAxiosParamCreator(configuration).apiSilentSignOutPost(options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSilentSignOutPost(options?: any): AxiosPromise<void> {
      return AuthApiFp(configuration).apiSilentSignOutPost(options)(axios, basePath)
    },
  }
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public apiSilentSignOutPost(options?: any) {
    return AuthApiFp(this.configuration).apiSilentSignOutPost(options)(this.axios, this.basePath)
  }
}

/**
 * AutopaymentsApi - axios parameter creator
 * @export
 */
export const AutopaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Метод получения доступных к созданию типов автоплатежа
     * @param {string} [serviceId] Идентификатор ТСП
     * @param {string} [serviceParams] параметры ТСП (набор json имя-значение)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApAvailableTypesGet(serviceId?: string, serviceParams?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/ap/availableTypes`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (serviceId !== undefined) {
        localVarQueryParameter['serviceId'] = serviceId
      }

      if (serviceParams !== undefined) {
        localVarQueryParameter['serviceParams'] = serviceParams
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [Authorize]
     * @summary Метод создания автоплатежа
     * @param {CreateAutopaymentRequest} [createAutopaymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApCreatePost(createAutopaymentRequest?: CreateAutopaymentRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/ap/create`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof createAutopaymentRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(createAutopaymentRequest !== undefined ? createAutopaymentRequest : {})
        : createAutopaymentRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [Authorize]
     * @summary Метод удоления автоплатежа
     * @param {DeleteAutopaymentRequest} [deleteAutopaymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApDeletePost(deleteAutopaymentRequest?: DeleteAutopaymentRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/ap/delete`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof deleteAutopaymentRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(deleteAutopaymentRequest !== undefined ? deleteAutopaymentRequest : {})
        : deleteAutopaymentRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [Authorize]
     * @summary Метод редактирования автоплатежа
     * @param {EditAutopaymentRequest} [editAutopaymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApEditPost(editAutopaymentRequest?: EditAutopaymentRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/ap/edit`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof editAutopaymentRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(editAutopaymentRequest !== undefined ? editAutopaymentRequest : {})
        : editAutopaymentRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [Authorize]
     * @summary Протухание кода отп
     * @param {string} [otpId] идетификатор отп
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApExpireOtpPost(otpId?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/ap/expireOtp`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (otpId !== undefined) {
        localVarQueryParameter['otpId'] = otpId
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [Authorize]
     * @summary Метод получения созданных автоплатежей
     * @param {GetAutopaymentsRequest} [getAutopaymentsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApGetPost(getAutopaymentsRequest?: GetAutopaymentsRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/ap/get`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof getAutopaymentsRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(getAutopaymentsRequest !== undefined ? getAutopaymentsRequest : {})
        : getAutopaymentsRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [Authorize]
     * @summary Проверка кода отп
     * @param {string} [apId] идентификатор автоплатежа
     * @param {string} [otpId] идетификатор отп
     * @param {string} [otp] код отп
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApReceiveOtpPost(apId?: string, otpId?: string, otp?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/ap/receiveOtp`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (apId !== undefined) {
        localVarQueryParameter['apId'] = apId
      }

      if (otpId !== undefined) {
        localVarQueryParameter['otpId'] = otpId
      }

      if (otp !== undefined) {
        localVarQueryParameter['otp'] = otp
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [Authorize]
     * @summary Повторная отправка кода отп
     * @param {string} [otpId] идетификатор отп
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApResendOtpPost(otpId?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/ap/resendOtp`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (otpId !== undefined) {
        localVarQueryParameter['otpId'] = otpId
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AutopaymentsApi - functional programming interface
 * @export
 */
export const AutopaymentsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Метод получения доступных к созданию типов автоплатежа
     * @param {string} [serviceId] Идентификатор ТСП
     * @param {string} [serviceParams] параметры ТСП (набор json имя-значение)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApAvailableTypesGet(
      serviceId?: string,
      serviceParams?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailableTypesResult> {
      const localVarAxiosArgs = AutopaymentsApiAxiosParamCreator(configuration).apiApAvailableTypesGet(
        serviceId,
        serviceParams,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [Authorize]
     * @summary Метод создания автоплатежа
     * @param {CreateAutopaymentRequest} [createAutopaymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApCreatePost(
      createAutopaymentRequest?: CreateAutopaymentRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateAutopaymentResult> {
      const localVarAxiosArgs = AutopaymentsApiAxiosParamCreator(configuration).apiApCreatePost(
        createAutopaymentRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [Authorize]
     * @summary Метод удоления автоплатежа
     * @param {DeleteAutopaymentRequest} [deleteAutopaymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApDeletePost(
      deleteAutopaymentRequest?: DeleteAutopaymentRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = AutopaymentsApiAxiosParamCreator(configuration).apiApDeletePost(
        deleteAutopaymentRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [Authorize]
     * @summary Метод редактирования автоплатежа
     * @param {EditAutopaymentRequest} [editAutopaymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApEditPost(
      editAutopaymentRequest?: EditAutopaymentRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = AutopaymentsApiAxiosParamCreator(configuration).apiApEditPost(
        editAutopaymentRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [Authorize]
     * @summary Протухание кода отп
     * @param {string} [otpId] идетификатор отп
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApExpireOtpPost(
      otpId?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = AutopaymentsApiAxiosParamCreator(configuration).apiApExpireOtpPost(otpId, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [Authorize]
     * @summary Метод получения созданных автоплатежей
     * @param {GetAutopaymentsRequest} [getAutopaymentsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApGetPost(
      getAutopaymentsRequest?: GetAutopaymentsRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAutopaymentsResult> {
      const localVarAxiosArgs = AutopaymentsApiAxiosParamCreator(configuration).apiApGetPost(
        getAutopaymentsRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [Authorize]
     * @summary Проверка кода отп
     * @param {string} [apId] идентификатор автоплатежа
     * @param {string} [otpId] идетификатор отп
     * @param {string} [otp] код отп
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApReceiveOtpPost(
      apId?: string,
      otpId?: string,
      otp?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorResponse> {
      const localVarAxiosArgs = AutopaymentsApiAxiosParamCreator(configuration).apiApReceiveOtpPost(
        apId,
        otpId,
        otp,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [Authorize]
     * @summary Повторная отправка кода отп
     * @param {string} [otpId] идетификатор отп
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApResendOtpPost(
      otpId?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
      const localVarAxiosArgs = AutopaymentsApiAxiosParamCreator(configuration).apiApResendOtpPost(otpId, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * AutopaymentsApi - factory interface
 * @export
 */
export const AutopaymentsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Метод получения доступных к созданию типов автоплатежа
     * @param {string} [serviceId] Идентификатор ТСП
     * @param {string} [serviceParams] параметры ТСП (набор json имя-значение)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApAvailableTypesGet(
      serviceId?: string,
      serviceParams?: string,
      options?: any
    ): AxiosPromise<AvailableTypesResult> {
      return AutopaymentsApiFp(configuration).apiApAvailableTypesGet(serviceId, serviceParams, options)(axios, basePath)
    },
    /**
     * [Authorize]
     * @summary Метод создания автоплатежа
     * @param {CreateAutopaymentRequest} [createAutopaymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApCreatePost(
      createAutopaymentRequest?: CreateAutopaymentRequest,
      options?: any
    ): AxiosPromise<CreateAutopaymentResult> {
      return AutopaymentsApiFp(configuration).apiApCreatePost(createAutopaymentRequest, options)(axios, basePath)
    },
    /**
     * [Authorize]
     * @summary Метод удоления автоплатежа
     * @param {DeleteAutopaymentRequest} [deleteAutopaymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApDeletePost(deleteAutopaymentRequest?: DeleteAutopaymentRequest, options?: any): AxiosPromise<object> {
      return AutopaymentsApiFp(configuration).apiApDeletePost(deleteAutopaymentRequest, options)(axios, basePath)
    },
    /**
     * [Authorize]
     * @summary Метод редактирования автоплатежа
     * @param {EditAutopaymentRequest} [editAutopaymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApEditPost(editAutopaymentRequest?: EditAutopaymentRequest, options?: any): AxiosPromise<object> {
      return AutopaymentsApiFp(configuration).apiApEditPost(editAutopaymentRequest, options)(axios, basePath)
    },
    /**
     * [Authorize]
     * @summary Протухание кода отп
     * @param {string} [otpId] идетификатор отп
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApExpireOtpPost(otpId?: string, options?: any): AxiosPromise<object> {
      return AutopaymentsApiFp(configuration).apiApExpireOtpPost(otpId, options)(axios, basePath)
    },
    /**
     * [Authorize]
     * @summary Метод получения созданных автоплатежей
     * @param {GetAutopaymentsRequest} [getAutopaymentsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApGetPost(getAutopaymentsRequest?: GetAutopaymentsRequest, options?: any): AxiosPromise<GetAutopaymentsResult> {
      return AutopaymentsApiFp(configuration).apiApGetPost(getAutopaymentsRequest, options)(axios, basePath)
    },
    /**
     * [Authorize]
     * @summary Проверка кода отп
     * @param {string} [apId] идентификатор автоплатежа
     * @param {string} [otpId] идетификатор отп
     * @param {string} [otp] код отп
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApReceiveOtpPost(apId?: string, otpId?: string, otp?: string, options?: any): AxiosPromise<ErrorResponse> {
      return AutopaymentsApiFp(configuration).apiApReceiveOtpPost(apId, otpId, otp, options)(axios, basePath)
    },
    /**
     * [Authorize]
     * @summary Повторная отправка кода отп
     * @param {string} [otpId] идетификатор отп
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiApResendOtpPost(otpId?: string, options?: any): AxiosPromise<object> {
      return AutopaymentsApiFp(configuration).apiApResendOtpPost(otpId, options)(axios, basePath)
    },
  }
}

/**
 * AutopaymentsApi - object-oriented interface
 * @export
 * @class AutopaymentsApi
 * @extends {BaseAPI}
 */
export class AutopaymentsApi extends BaseAPI {
  /**
   *
   * @summary Метод получения доступных к созданию типов автоплатежа
   * @param {string} [serviceId] Идентификатор ТСП
   * @param {string} [serviceParams] параметры ТСП (набор json имя-значение)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutopaymentsApi
   */
  public apiApAvailableTypesGet(serviceId?: string, serviceParams?: string, options?: any) {
    return AutopaymentsApiFp(this.configuration).apiApAvailableTypesGet(
      serviceId,
      serviceParams,
      options
    )(this.axios, this.basePath)
  }

  /**
   * [Authorize]
   * @summary Метод создания автоплатежа
   * @param {CreateAutopaymentRequest} [createAutopaymentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutopaymentsApi
   */
  public apiApCreatePost(createAutopaymentRequest?: CreateAutopaymentRequest, options?: any) {
    return AutopaymentsApiFp(this.configuration).apiApCreatePost(createAutopaymentRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   * [Authorize]
   * @summary Метод удоления автоплатежа
   * @param {DeleteAutopaymentRequest} [deleteAutopaymentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutopaymentsApi
   */
  public apiApDeletePost(deleteAutopaymentRequest?: DeleteAutopaymentRequest, options?: any) {
    return AutopaymentsApiFp(this.configuration).apiApDeletePost(deleteAutopaymentRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   * [Authorize]
   * @summary Метод редактирования автоплатежа
   * @param {EditAutopaymentRequest} [editAutopaymentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutopaymentsApi
   */
  public apiApEditPost(editAutopaymentRequest?: EditAutopaymentRequest, options?: any) {
    return AutopaymentsApiFp(this.configuration).apiApEditPost(editAutopaymentRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   * [Authorize]
   * @summary Протухание кода отп
   * @param {string} [otpId] идетификатор отп
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutopaymentsApi
   */
  public apiApExpireOtpPost(otpId?: string, options?: any) {
    return AutopaymentsApiFp(this.configuration).apiApExpireOtpPost(otpId, options)(this.axios, this.basePath)
  }

  /**
   * [Authorize]
   * @summary Метод получения созданных автоплатежей
   * @param {GetAutopaymentsRequest} [getAutopaymentsRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutopaymentsApi
   */
  public apiApGetPost(getAutopaymentsRequest?: GetAutopaymentsRequest, options?: any) {
    return AutopaymentsApiFp(this.configuration).apiApGetPost(getAutopaymentsRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   * [Authorize]
   * @summary Проверка кода отп
   * @param {string} [apId] идентификатор автоплатежа
   * @param {string} [otpId] идетификатор отп
   * @param {string} [otp] код отп
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutopaymentsApi
   */
  public apiApReceiveOtpPost(apId?: string, otpId?: string, otp?: string, options?: any) {
    return AutopaymentsApiFp(this.configuration).apiApReceiveOtpPost(
      apId,
      otpId,
      otp,
      options
    )(this.axios, this.basePath)
  }

  /**
   * [Authorize]
   * @summary Повторная отправка кода отп
   * @param {string} [otpId] идетификатор отп
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutopaymentsApi
   */
  public apiApResendOtpPost(otpId?: string, options?: any) {
    return AutopaymentsApiFp(this.configuration).apiApResendOtpPost(otpId, options)(this.axios, this.basePath)
  }
}

/**
 * CmsApi - axios parameter creator
 * @export
 */
export const CmsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Метод получения баннеров из CMS
     * @param {string} [place] местоположение баннера. значения соответствуют типу данных BannerPlaceEnum
     * @param {string} [words] ключевые слова, для идентификации баннера (если не передано будет возвращен весь набор)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCmsGetBannersGet(place?: string, words?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/cms/getBanners`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (place !== undefined) {
        localVarQueryParameter['place'] = place
      }

      if (words !== undefined) {
        localVarQueryParameter['words'] = words
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [code]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCmsGetErrorInfoGet(code?: number, options: any = {}): RequestArgs {
      const localVarPath = `/api/cms/getErrorInfo`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (code !== undefined) {
        localVarQueryParameter['code'] = code
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CmsApi - functional programming interface
 * @export
 */
export const CmsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Метод получения баннеров из CMS
     * @param {string} [place] местоположение баннера. значения соответствуют типу данных BannerPlaceEnum
     * @param {string} [words] ключевые слова, для идентификации баннера (если не передано будет возвращен весь набор)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCmsGetBannersGet(
      place?: string,
      words?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Banner>> {
      const localVarAxiosArgs = CmsApiAxiosParamCreator(configuration).apiCmsGetBannersGet(place, words, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {number} [code]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCmsGetErrorInfoGet(
      code?: number,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorMessage> {
      const localVarAxiosArgs = CmsApiAxiosParamCreator(configuration).apiCmsGetErrorInfoGet(code, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * CmsApi - factory interface
 * @export
 */
export const CmsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     *
     * @summary Метод получения баннеров из CMS
     * @param {string} [place] местоположение баннера. значения соответствуют типу данных BannerPlaceEnum
     * @param {string} [words] ключевые слова, для идентификации баннера (если не передано будет возвращен весь набор)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCmsGetBannersGet(place?: string, words?: string, options?: any): AxiosPromise<Array<Banner>> {
      return CmsApiFp(configuration).apiCmsGetBannersGet(place, words, options)(axios, basePath)
    },
    /**
     *
     * @param {number} [code]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCmsGetErrorInfoGet(code?: number, options?: any): AxiosPromise<ErrorMessage> {
      return CmsApiFp(configuration).apiCmsGetErrorInfoGet(code, options)(axios, basePath)
    },
  }
}

/**
 * CmsApi - object-oriented interface
 * @export
 * @class CmsApi
 * @extends {BaseAPI}
 */
export class CmsApi extends BaseAPI {
  /**
   *
   * @summary Метод получения баннеров из CMS
   * @param {string} [place] местоположение баннера. значения соответствуют типу данных BannerPlaceEnum
   * @param {string} [words] ключевые слова, для идентификации баннера (если не передано будет возвращен весь набор)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CmsApi
   */
  public apiCmsGetBannersGet(place?: string, words?: string, options?: any) {
    return CmsApiFp(this.configuration).apiCmsGetBannersGet(place, words, options)(this.axios, this.basePath)
  }

  /**
   *
   * @param {number} [code]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CmsApi
   */
  public apiCmsGetErrorInfoGet(code?: number, options?: any) {
    return CmsApiFp(this.configuration).apiCmsGetErrorInfoGet(code, options)(this.axios, this.basePath)
  }
}

/**
 * ConfigApi - axios parameter creator
 * @export
 */
export const ConfigApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiConfigGet(options: any = {}): RequestArgs {
      const localVarPath = `/api/config`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSuppressGet(options: any = {}): RequestArgs {
      const localVarPath = `/api/suppress`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ConfigApi - functional programming interface
 * @export
 */
export const ConfigApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiConfigGet(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpaConfig> {
      const localVarAxiosArgs = ConfigApiAxiosParamCreator(configuration).apiConfigGet(options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSuppressGet(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuppressDateResult> {
      const localVarAxiosArgs = ConfigApiAxiosParamCreator(configuration).apiSuppressGet(options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ConfigApi - factory interface
 * @export
 */
export const ConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiConfigGet(options?: any): AxiosPromise<SpaConfig> {
      return ConfigApiFp(configuration).apiConfigGet(options)(axios, basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSuppressGet(options?: any): AxiosPromise<SuppressDateResult> {
      return ConfigApiFp(configuration).apiSuppressGet(options)(axios, basePath)
    },
  }
}

/**
 * ConfigApi - object-oriented interface
 * @export
 * @class ConfigApi
 * @extends {BaseAPI}
 */
export class ConfigApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigApi
   */
  public apiConfigGet(options?: any) {
    return ConfigApiFp(this.configuration).apiConfigGet(options)(this.axios, this.basePath)
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigApi
   */
  public apiSuppressGet(options?: any) {
    return ConfigApiFp(this.configuration).apiSuppressGet(options)(this.axios, this.basePath)
  }
}

/**
 * PaymentApi - axios parameter creator
 * @export
 */
export const PaymentApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Подтвердение продавца и получение сеанса для каждого платежного запроса.
     * @param {string} [validationUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentApplePayValidateMerchantPost(validationUrl?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/payment/applePay/validateMerchant`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (validationUrl !== undefined) {
        localVarQueryParameter['validationUrl'] = validationUrl
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Получение баланса кэшбека
     * @param {string} [phone]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentCashbakBalanceGet(phone?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/payment/cashbakBalance`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (phone !== undefined) {
        localVarQueryParameter['phone'] = phone
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Подтверждение операции одноразовым паролем
     * @param {string} [mdOrder] Уникальный номер операции на ПЦ
     * @param {string} [otp] Одноразовый пароль
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentCheckotpPost(mdOrder?: string, otp?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/payment/checkotp`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (mdOrder !== undefined) {
        localVarQueryParameter['mdOrder'] = mdOrder
      }

      if (otp !== undefined) {
        localVarQueryParameter['otp'] = otp
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Инициализация платежа
     * @param {PaymentRequest} [paymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentDoPost(paymentRequest?: PaymentRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/payment/do`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof paymentRequest !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(paymentRequest !== undefined ? paymentRequest : {})
        : paymentRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Завершить операцию с 3DSecure2
     * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentFinish3ds2Post(finish3DsRequest?: Finish3DsRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/payment/finish3ds2`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof finish3DsRequest !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(finish3DsRequest !== undefined ? finish3DsRequest : {})
        : finish3DsRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Завершить операцию с 3DSecure
     * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentFinish3dsPost(finish3DsRequest?: Finish3DsRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/payment/finish3ds`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof finish3DsRequest !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(finish3DsRequest !== undefined ? finish3DsRequest : {})
        : finish3DsRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Запрос на получение комиссии
     * @param {GetPaymentTermRequest} [getPaymentTermRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentGetTermsPost(getPaymentTermRequest?: GetPaymentTermRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/payment/getTerms`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof getPaymentTermRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(getPaymentTermRequest !== undefined ? getPaymentTermRequest : {})
        : getPaymentTermRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Возвращает ТСП мобильного оператора по номеру тебефона
     * @param {string} [phone]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentMncGet(phone?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/payment/mnc`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (phone !== undefined) {
        localVarQueryParameter['phone'] = phone
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Повторная отправка одноразового пароля
     * @param {string} [mdOrder] Уникальный номер операции на ПЦ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentReSendOtpPost(mdOrder?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/payment/reSendOtp`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (mdOrder !== undefined) {
        localVarQueryParameter['mdOrder'] = mdOrder
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Получение рекомендованной  суммы к оплате
     * @param {string} [phone]
     * @param {string} [region]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentRecomendationGet(phone?: string, region?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/payment/recomendation`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (phone !== undefined) {
        localVarQueryParameter['phone'] = phone
      }

      if (region !== undefined) {
        localVarQueryParameter['region'] = region
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Завершение платежа по  SamsungPay
     * @param {string} token
     * @param {string} [refId]
     * @param {PaymentRequest} [paymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentSamsungCommitTransactionTokenPost(
      token: string,
      refId?: string,
      paymentRequest?: PaymentRequest,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'token' is not null or undefined
      if (token === null || token === undefined) {
        throw new RequiredError(
          'token',
          'Required parameter token was null or undefined when calling apiPaymentSamsungCommitTransactionTokenPost.'
        )
      }
      const localVarPath = `/api/payment/samsung/commitTransaction/{token}`.replace(
        `{${'token'}}`,
        encodeURIComponent(String(token))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (refId !== undefined) {
        localVarQueryParameter['ref_id'] = refId
      }

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof paymentRequest !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(paymentRequest !== undefined ? paymentRequest : {})
        : paymentRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Создание транзакции для инициализации платежа SamsungPay
     * @param {CreateTransactionRequest} [createTransactionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentSamsungCreateTransactionPost(
      createTransactionRequest?: CreateTransactionRequest,
      options: any = {}
    ): RequestArgs {
      const localVarPath = `/api/payment/samsung/createTransaction`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof createTransactionRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(createTransactionRequest !== undefined ? createTransactionRequest : {})
        : createTransactionRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Возвращает ТСП мобильного оператора по номеру телефона
     * @param {string} [phone]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentServiceInfoGet(phone?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/payment/serviceInfo`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (phone !== undefined) {
        localVarQueryParameter['phone'] = phone
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Проведение платежа Pay сервисами
     * @param {PaymentRequest} [paymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentTokenizedPost(paymentRequest?: PaymentRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/payment/tokenized`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof paymentRequest !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(paymentRequest !== undefined ? paymentRequest : {})
        : paymentRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PaymentApi - functional programming interface
 * @export
 */
export const PaymentApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Подтвердение продавца и получение сеанса для каждого платежного запроса.
     * @param {string} [validationUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentApplePayValidateMerchantPost(
      validationUrl?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplePayResponse> {
      const localVarAxiosArgs = PaymentApiAxiosParamCreator(configuration).apiPaymentApplePayValidateMerchantPost(
        validationUrl,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Получение баланса кэшбека
     * @param {string} [phone]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentCashbakBalanceGet(
      phone?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CashBackBalanceResult> {
      const localVarAxiosArgs = PaymentApiAxiosParamCreator(configuration).apiPaymentCashbakBalanceGet(phone, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Подтверждение операции одноразовым паролем
     * @param {string} [mdOrder] Уникальный номер операции на ПЦ
     * @param {string} [otp] Одноразовый пароль
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentCheckotpPost(
      mdOrder?: string,
      otp?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorResponse> {
      const localVarAxiosArgs = PaymentApiAxiosParamCreator(configuration).apiPaymentCheckotpPost(mdOrder, otp, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Инициализация платежа
     * @param {PaymentRequest} [paymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentDoPost(
      paymentRequest?: PaymentRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResponse> {
      const localVarAxiosArgs = PaymentApiAxiosParamCreator(configuration).apiPaymentDoPost(paymentRequest, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Завершить операцию с 3DSecure2
     * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentFinish3ds2Post(
      finish3DsRequest?: Finish3DsRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResponse> {
      const localVarAxiosArgs = PaymentApiAxiosParamCreator(configuration).apiPaymentFinish3ds2Post(
        finish3DsRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Завершить операцию с 3DSecure
     * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentFinish3dsPost(
      finish3DsRequest?: Finish3DsRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResponse> {
      const localVarAxiosArgs = PaymentApiAxiosParamCreator(configuration).apiPaymentFinish3dsPost(
        finish3DsRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Запрос на получение комиссии
     * @param {GetPaymentTermRequest} [getPaymentTermRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentGetTermsPost(
      getPaymentTermRequest?: GetPaymentTermRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPaymentTermsResult> {
      const localVarAxiosArgs = PaymentApiAxiosParamCreator(configuration).apiPaymentGetTermsPost(
        getPaymentTermRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Возвращает ТСП мобильного оператора по номеру тебефона
     * @param {string} [phone]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentMncGet(
      phone?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMncResult> {
      const localVarAxiosArgs = PaymentApiAxiosParamCreator(configuration).apiPaymentMncGet(phone, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Повторная отправка одноразового пароля
     * @param {string} [mdOrder] Уникальный номер операции на ПЦ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentReSendOtpPost(
      mdOrder?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean> {
      const localVarAxiosArgs = PaymentApiAxiosParamCreator(configuration).apiPaymentReSendOtpPost(mdOrder, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Получение рекомендованной  суммы к оплате
     * @param {string} [phone]
     * @param {string} [region]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentRecomendationGet(
      phone?: string,
      region?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecomendationAmountInfo> {
      const localVarAxiosArgs = PaymentApiAxiosParamCreator(configuration).apiPaymentRecomendationGet(
        phone,
        region,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Завершение платежа по  SamsungPay
     * @param {string} token
     * @param {string} [refId]
     * @param {PaymentRequest} [paymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentSamsungCommitTransactionTokenPost(
      token: string,
      refId?: string,
      paymentRequest?: PaymentRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResponse> {
      const localVarAxiosArgs = PaymentApiAxiosParamCreator(configuration).apiPaymentSamsungCommitTransactionTokenPost(
        token,
        refId,
        paymentRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Создание транзакции для инициализации платежа SamsungPay
     * @param {CreateTransactionRequest} [createTransactionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentSamsungCreateTransactionPost(
      createTransactionRequest?: CreateTransactionRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = PaymentApiAxiosParamCreator(configuration).apiPaymentSamsungCreateTransactionPost(
        createTransactionRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Возвращает ТСП мобильного оператора по номеру телефона
     * @param {string} [phone]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentServiceInfoGet(
      phone?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceInfo> {
      const localVarAxiosArgs = PaymentApiAxiosParamCreator(configuration).apiPaymentServiceInfoGet(phone, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Проведение платежа Pay сервисами
     * @param {PaymentRequest} [paymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentTokenizedPost(
      paymentRequest?: PaymentRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResponse> {
      const localVarAxiosArgs = PaymentApiAxiosParamCreator(configuration).apiPaymentTokenizedPost(
        paymentRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * PaymentApi - factory interface
 * @export
 */
export const PaymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     *
     * @summary Подтвердение продавца и получение сеанса для каждого платежного запроса.
     * @param {string} [validationUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentApplePayValidateMerchantPost(validationUrl?: string, options?: any): AxiosPromise<ApplePayResponse> {
      return PaymentApiFp(configuration).apiPaymentApplePayValidateMerchantPost(validationUrl, options)(axios, basePath)
    },
    /**
     *
     * @summary Получение баланса кэшбека
     * @param {string} [phone]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentCashbakBalanceGet(phone?: string, options?: any): AxiosPromise<CashBackBalanceResult> {
      return PaymentApiFp(configuration).apiPaymentCashbakBalanceGet(phone, options)(axios, basePath)
    },
    /**
     *
     * @summary Подтверждение операции одноразовым паролем
     * @param {string} [mdOrder] Уникальный номер операции на ПЦ
     * @param {string} [otp] Одноразовый пароль
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentCheckotpPost(mdOrder?: string, otp?: string, options?: any): AxiosPromise<ErrorResponse> {
      return PaymentApiFp(configuration).apiPaymentCheckotpPost(mdOrder, otp, options)(axios, basePath)
    },
    /**
     *
     * @summary Инициализация платежа
     * @param {PaymentRequest} [paymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentDoPost(paymentRequest?: PaymentRequest, options?: any): AxiosPromise<OperationResponse> {
      return PaymentApiFp(configuration).apiPaymentDoPost(paymentRequest, options)(axios, basePath)
    },
    /**
     *
     * @summary Завершить операцию с 3DSecure2
     * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentFinish3ds2Post(finish3DsRequest?: Finish3DsRequest, options?: any): AxiosPromise<OperationResponse> {
      return PaymentApiFp(configuration).apiPaymentFinish3ds2Post(finish3DsRequest, options)(axios, basePath)
    },
    /**
     *
     * @summary Завершить операцию с 3DSecure
     * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentFinish3dsPost(finish3DsRequest?: Finish3DsRequest, options?: any): AxiosPromise<OperationResponse> {
      return PaymentApiFp(configuration).apiPaymentFinish3dsPost(finish3DsRequest, options)(axios, basePath)
    },
    /**
     *
     * @summary Запрос на получение комиссии
     * @param {GetPaymentTermRequest} [getPaymentTermRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentGetTermsPost(
      getPaymentTermRequest?: GetPaymentTermRequest,
      options?: any
    ): AxiosPromise<GetPaymentTermsResult> {
      return PaymentApiFp(configuration).apiPaymentGetTermsPost(getPaymentTermRequest, options)(axios, basePath)
    },
    /**
     *
     * @summary Возвращает ТСП мобильного оператора по номеру тебефона
     * @param {string} [phone]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentMncGet(phone?: string, options?: any): AxiosPromise<GetMncResult> {
      return PaymentApiFp(configuration).apiPaymentMncGet(phone, options)(axios, basePath)
    },
    /**
     *
     * @summary Повторная отправка одноразового пароля
     * @param {string} [mdOrder] Уникальный номер операции на ПЦ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentReSendOtpPost(mdOrder?: string, options?: any): AxiosPromise<boolean> {
      return PaymentApiFp(configuration).apiPaymentReSendOtpPost(mdOrder, options)(axios, basePath)
    },
    /**
     *
     * @summary Получение рекомендованной  суммы к оплате
     * @param {string} [phone]
     * @param {string} [region]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentRecomendationGet(phone?: string, region?: string, options?: any): AxiosPromise<RecomendationAmountInfo> {
      return PaymentApiFp(configuration).apiPaymentRecomendationGet(phone, region, options)(axios, basePath)
    },
    /**
     *
     * @summary Завершение платежа по  SamsungPay
     * @param {string} token
     * @param {string} [refId]
     * @param {PaymentRequest} [paymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentSamsungCommitTransactionTokenPost(
      token: string,
      refId?: string,
      paymentRequest?: PaymentRequest,
      options?: any
    ): AxiosPromise<OperationResponse> {
      return PaymentApiFp(configuration).apiPaymentSamsungCommitTransactionTokenPost(
        token,
        refId,
        paymentRequest,
        options
      )(axios, basePath)
    },
    /**
     *
     * @summary Создание транзакции для инициализации платежа SamsungPay
     * @param {CreateTransactionRequest} [createTransactionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentSamsungCreateTransactionPost(
      createTransactionRequest?: CreateTransactionRequest,
      options?: any
    ): AxiosPromise<void> {
      return PaymentApiFp(configuration).apiPaymentSamsungCreateTransactionPost(createTransactionRequest, options)(
        axios,
        basePath
      )
    },
    /**
     *
     * @summary Возвращает ТСП мобильного оператора по номеру телефона
     * @param {string} [phone]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentServiceInfoGet(phone?: string, options?: any): AxiosPromise<ServiceInfo> {
      return PaymentApiFp(configuration).apiPaymentServiceInfoGet(phone, options)(axios, basePath)
    },
    /**
     *
     * @summary Проведение платежа Pay сервисами
     * @param {PaymentRequest} [paymentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPaymentTokenizedPost(paymentRequest?: PaymentRequest, options?: any): AxiosPromise<OperationResponse> {
      return PaymentApiFp(configuration).apiPaymentTokenizedPost(paymentRequest, options)(axios, basePath)
    },
  }
}

/**
 * PaymentApi - object-oriented interface
 * @export
 * @class PaymentApi
 * @extends {BaseAPI}
 */
export class PaymentApi extends BaseAPI {
  /**
   *
   * @summary Подтвердение продавца и получение сеанса для каждого платежного запроса.
   * @param {string} [validationUrl]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public apiPaymentApplePayValidateMerchantPost(validationUrl?: string, options?: any) {
    return PaymentApiFp(this.configuration).apiPaymentApplePayValidateMerchantPost(validationUrl, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   *
   * @summary Получение баланса кэшбека
   * @param {string} [phone]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public apiPaymentCashbakBalanceGet(phone?: string, options?: any) {
    return PaymentApiFp(this.configuration).apiPaymentCashbakBalanceGet(phone, options)(this.axios, this.basePath)
  }

  /**
   *
   * @summary Подтверждение операции одноразовым паролем
   * @param {string} [mdOrder] Уникальный номер операции на ПЦ
   * @param {string} [otp] Одноразовый пароль
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public apiPaymentCheckotpPost(mdOrder?: string, otp?: string, options?: any) {
    return PaymentApiFp(this.configuration).apiPaymentCheckotpPost(mdOrder, otp, options)(this.axios, this.basePath)
  }

  /**
   *
   * @summary Инициализация платежа
   * @param {PaymentRequest} [paymentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public apiPaymentDoPost(paymentRequest?: PaymentRequest, options?: any) {
    return PaymentApiFp(this.configuration).apiPaymentDoPost(paymentRequest, options)(this.axios, this.basePath)
  }

  /**
   *
   * @summary Завершить операцию с 3DSecure2
   * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public apiPaymentFinish3ds2Post(finish3DsRequest?: Finish3DsRequest, options?: any) {
    return PaymentApiFp(this.configuration).apiPaymentFinish3ds2Post(finish3DsRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   *
   * @summary Завершить операцию с 3DSecure
   * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public apiPaymentFinish3dsPost(finish3DsRequest?: Finish3DsRequest, options?: any) {
    return PaymentApiFp(this.configuration).apiPaymentFinish3dsPost(finish3DsRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   *
   * @summary Запрос на получение комиссии
   * @param {GetPaymentTermRequest} [getPaymentTermRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public apiPaymentGetTermsPost(getPaymentTermRequest?: GetPaymentTermRequest, options?: any) {
    return PaymentApiFp(this.configuration).apiPaymentGetTermsPost(getPaymentTermRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   *
   * @summary Возвращает ТСП мобильного оператора по номеру тебефона
   * @param {string} [phone]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public apiPaymentMncGet(phone?: string, options?: any) {
    return PaymentApiFp(this.configuration).apiPaymentMncGet(phone, options)(this.axios, this.basePath)
  }

  /**
   *
   * @summary Повторная отправка одноразового пароля
   * @param {string} [mdOrder] Уникальный номер операции на ПЦ
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public apiPaymentReSendOtpPost(mdOrder?: string, options?: any) {
    return PaymentApiFp(this.configuration).apiPaymentReSendOtpPost(mdOrder, options)(this.axios, this.basePath)
  }

  /**
   *
   * @summary Получение рекомендованной  суммы к оплате
   * @param {string} [phone]
   * @param {string} [region]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public apiPaymentRecomendationGet(phone?: string, region?: string, options?: any) {
    return PaymentApiFp(this.configuration).apiPaymentRecomendationGet(
      phone,
      region,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary Завершение платежа по  SamsungPay
   * @param {string} token
   * @param {string} [refId]
   * @param {PaymentRequest} [paymentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public apiPaymentSamsungCommitTransactionTokenPost(
    token: string,
    refId?: string,
    paymentRequest?: PaymentRequest,
    options?: any
  ) {
    return PaymentApiFp(this.configuration).apiPaymentSamsungCommitTransactionTokenPost(
      token,
      refId,
      paymentRequest,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @summary Создание транзакции для инициализации платежа SamsungPay
   * @param {CreateTransactionRequest} [createTransactionRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public apiPaymentSamsungCreateTransactionPost(createTransactionRequest?: CreateTransactionRequest, options?: any) {
    return PaymentApiFp(this.configuration).apiPaymentSamsungCreateTransactionPost(createTransactionRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   *
   * @summary Возвращает ТСП мобильного оператора по номеру телефона
   * @param {string} [phone]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public apiPaymentServiceInfoGet(phone?: string, options?: any) {
    return PaymentApiFp(this.configuration).apiPaymentServiceInfoGet(phone, options)(this.axios, this.basePath)
  }

  /**
   *
   * @summary Проведение платежа Pay сервисами
   * @param {PaymentRequest} [paymentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApi
   */
  public apiPaymentTokenizedPost(paymentRequest?: PaymentRequest, options?: any) {
    return PaymentApiFp(this.configuration).apiPaymentTokenizedPost(paymentRequest, options)(this.axios, this.basePath)
  }
}

/**
 * ProcessingApi - axios parameter creator
 * @export
 */
export const ProcessingApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * [Authorize, AntiForgeryToken]
     * @summary Создание нового ПИ
     * @param {CreateBindingRequest} [createBindingRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingCreateBindingPost(createBindingRequest?: CreateBindingRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/createBinding`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof createBindingRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(createBindingRequest !== undefined ? createBindingRequest : {})
        : createBindingRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Завершить операцию с 3DSecure2
     * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingFinish3ds2Post(finish3DsRequest?: Finish3DsRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/finish3ds2`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof finish3DsRequest !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(finish3DsRequest !== undefined ? finish3DsRequest : {})
        : finish3DsRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Завершить операцию с 3DSecure
     * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingFinish3dsPost(finish3DsRequest?: Finish3DsRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/finish3ds`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof finish3DsRequest !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(finish3DsRequest !== undefined ? finish3DsRequest : {})
        : finish3DsRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [Authorize]
     * @param {string} [number]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetAccountOperationsPost(
      number?: string,
      dateFrom?: string,
      dateTo?: string,
      options: any = {}
    ): RequestArgs {
      const localVarPath = `/api/processing/getAccountOperations`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (number !== undefined) {
        localVarQueryParameter['number'] = number
      }

      if (dateFrom !== undefined) {
        localVarQueryParameter['dateFrom'] = dateFrom
      }

      if (dateTo !== undefined) {
        localVarQueryParameter['dateTo'] = dateTo
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [Authorize, AntiForgeryToken]
     * @param {GetBindingsRequest} [getBindingsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetBindingsPost(getBindingsRequest?: GetBindingsRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/getBindings`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof getBindingsRequest !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(getBindingsRequest !== undefined ? getBindingsRequest : {})
        : getBindingsRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [AntiForgeryToken]
     * @summary Получение категорий каталога
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetCategoriesGet(options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/getCategories`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [Authorize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetLoansListGet(options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/getLoansList`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [AntiForgeryToken]
     * @param {string} [mdOrder]
     * @param {string} [refNumber]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetOperationDetailsGet(mdOrder?: string, refNumber?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/getOperationDetails`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (mdOrder !== undefined) {
        localVarQueryParameter['mdOrder'] = mdOrder
      }

      if (refNumber !== undefined) {
        localVarQueryParameter['ref_number'] = refNumber
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [AntiForgeryToken]
     * @summary Получение информации по привязанному платежному инструменту – продукту Банка
     * @param {string} [bindingId] Уникальный идентификатор ПИ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetProductBindingWithBalanceGet(bindingId?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/getProductBindingWithBalance`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (bindingId !== undefined) {
        localVarQueryParameter['bindingId'] = bindingId
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [AntiForgeryToken]
     * @summary Получение ТСП по id
     * @param {string} [serviceId] Идентификатор ТСП
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetServiceByIdGet(serviceId?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/getServiceById`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (serviceId !== undefined) {
        localVarQueryParameter['serviceId'] = serviceId
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [AntiForgeryToken]
     * @summary Получение каталога ТСП
     * @param {string} [category] Название категории, для которой запрашивается каталог
     * @param {string} [region] Регион для которого запрашивается каталог. MOW(Москва по умолчанию)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetServicesGet(category?: string, region?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/getServices`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (category !== undefined) {
        localVarQueryParameter['category'] = category
      }

      if (region !== undefined) {
        localVarQueryParameter['region'] = region
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [AntiForgeryToken]
     * @param {GetTransferTermsRequest} [getTransferTermsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetTransferTermsPost(
      getTransferTermsRequest?: GetTransferTermsRequest,
      options: any = {}
    ): RequestArgs {
      const localVarPath = `/api/processing/getTransferTerms`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof getTransferTermsRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(getTransferTermsRequest !== undefined ? getTransferTermsRequest : {})
        : getTransferTermsRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Идентификация пользователя по 3ds 2.0.
     * @param {ThreeDsProceedDto} [threeDsProceedDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingProceed3ds2Post(threeDsProceedDto?: ThreeDsProceedDto, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/proceed3ds2`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof threeDsProceedDto !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(threeDsProceedDto !== undefined ? threeDsProceedDto : {})
        : threeDsProceedDto || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [query]
     * @param {string} [region]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingSearchServicesGet(query?: string, region?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/searchServices`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (query !== undefined) {
        localVarQueryParameter['query'] = query
      }

      if (region !== undefined) {
        localVarQueryParameter['region'] = region
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {SendReceiptRequest} [sendReceiptRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingSendReceiptPost(sendReceiptRequest?: SendReceiptRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/sendReceipt`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof sendReceiptRequest !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(sendReceiptRequest !== undefined ? sendReceiptRequest : {})
        : sendReceiptRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [AntiForgeryToken]
     * @param {TransferRequest} [transferRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferPost(transferRequest?: TransferRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/transfer`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof transferRequest !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(transferRequest !== undefined ? transferRequest : {})
        : transferRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProcessingApi - functional programming interface
 * @export
 */
export const ProcessingApiFp = function (configuration?: Configuration) {
  return {
    /**
     * [Authorize, AntiForgeryToken]
     * @summary Создание нового ПИ
     * @param {CreateBindingRequest} [createBindingRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingCreateBindingPost(
      createBindingRequest?: CreateBindingRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBindingResult> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingCreateBindingPost(
        createBindingRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Завершить операцию с 3DSecure2
     * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingFinish3ds2Post(
      finish3DsRequest?: Finish3DsRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmBindingResponse> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingFinish3ds2Post(
        finish3DsRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Завершить операцию с 3DSecure
     * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingFinish3dsPost(
      finish3DsRequest?: Finish3DsRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmBindingResponse> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingFinish3dsPost(
        finish3DsRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [Authorize]
     * @param {string} [number]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetAccountOperationsPost(
      number?: string,
      dateFrom?: string,
      dateTo?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAccountOperationsResponse> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingGetAccountOperationsPost(
        number,
        dateFrom,
        dateTo,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [Authorize, AntiForgeryToken]
     * @param {GetBindingsRequest} [getBindingsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetBindingsPost(
      getBindingsRequest?: GetBindingsRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBindingsResponse> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingGetBindingsPost(
        getBindingsRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [AntiForgeryToken]
     * @summary Получение категорий каталога
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetCategoriesGet(
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceCategoryInfo>> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingGetCategoriesGet(options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [Authorize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetLoansListGet(
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLoansListResponse> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingGetLoansListGet(options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [AntiForgeryToken]
     * @param {string} [mdOrder]
     * @param {string} [refNumber]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetOperationDetailsGet(
      mdOrder?: string,
      refNumber?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationDetails> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingGetOperationDetailsGet(
        mdOrder,
        refNumber,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [AntiForgeryToken]
     * @summary Получение информации по привязанному платежному инструменту – продукту Банка
     * @param {string} [bindingId] Уникальный идентификатор ПИ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetProductBindingWithBalanceGet(
      bindingId?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBindingResponse> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(
        configuration
      ).apiProcessingGetProductBindingWithBalanceGet(bindingId, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [AntiForgeryToken]
     * @summary Получение ТСП по id
     * @param {string} [serviceId] Идентификатор ТСП
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetServiceByIdGet(
      serviceId?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceInfo> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingGetServiceByIdGet(
        serviceId,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [AntiForgeryToken]
     * @summary Получение каталога ТСП
     * @param {string} [category] Название категории, для которой запрашивается каталог
     * @param {string} [region] Регион для которого запрашивается каталог. MOW(Москва по умолчанию)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetServicesGet(
      category?: string,
      region?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceInfo>> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingGetServicesGet(
        category,
        region,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [AntiForgeryToken]
     * @param {GetTransferTermsRequest} [getTransferTermsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetTransferTermsPost(
      getTransferTermsRequest?: GetTransferTermsRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTransferTermsResponse> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingGetTransferTermsPost(
        getTransferTermsRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @summary Идентификация пользователя по 3ds 2.0.
     * @param {ThreeDsProceedDto} [threeDsProceedDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingProceed3ds2Post(
      threeDsProceedDto?: ThreeDsProceedDto,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBindingResult> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingProceed3ds2Post(
        threeDsProceedDto,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {string} [query]
     * @param {string} [region]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingSearchServicesGet(
      query?: string,
      region?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchServiceResult>> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingSearchServicesGet(
        query,
        region,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {SendReceiptRequest} [sendReceiptRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingSendReceiptPost(
      sendReceiptRequest?: SendReceiptRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendReceiptResult> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingSendReceiptPost(
        sendReceiptRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [AntiForgeryToken]
     * @param {TransferRequest} [transferRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferPost(
      transferRequest?: TransferRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResponse> {
      const localVarAxiosArgs = ProcessingApiAxiosParamCreator(configuration).apiProcessingTransferPost(
        transferRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ProcessingApi - factory interface
 * @export
 */
export const ProcessingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     * [Authorize, AntiForgeryToken]
     * @summary Создание нового ПИ
     * @param {CreateBindingRequest} [createBindingRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingCreateBindingPost(
      createBindingRequest?: CreateBindingRequest,
      options?: any
    ): AxiosPromise<CreateBindingResult> {
      return ProcessingApiFp(configuration).apiProcessingCreateBindingPost(createBindingRequest, options)(
        axios,
        basePath
      )
    },
    /**
     *
     * @summary Завершить операцию с 3DSecure2
     * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingFinish3ds2Post(
      finish3DsRequest?: Finish3DsRequest,
      options?: any
    ): AxiosPromise<ConfirmBindingResponse> {
      return ProcessingApiFp(configuration).apiProcessingFinish3ds2Post(finish3DsRequest, options)(axios, basePath)
    },
    /**
     *
     * @summary Завершить операцию с 3DSecure
     * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingFinish3dsPost(
      finish3DsRequest?: Finish3DsRequest,
      options?: any
    ): AxiosPromise<ConfirmBindingResponse> {
      return ProcessingApiFp(configuration).apiProcessingFinish3dsPost(finish3DsRequest, options)(axios, basePath)
    },
    /**
     * [Authorize]
     * @param {string} [number]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetAccountOperationsPost(
      number?: string,
      dateFrom?: string,
      dateTo?: string,
      options?: any
    ): AxiosPromise<GetAccountOperationsResponse> {
      return ProcessingApiFp(configuration).apiProcessingGetAccountOperationsPost(
        number,
        dateFrom,
        dateTo,
        options
      )(axios, basePath)
    },
    /**
     * [Authorize, AntiForgeryToken]
     * @param {GetBindingsRequest} [getBindingsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetBindingsPost(
      getBindingsRequest?: GetBindingsRequest,
      options?: any
    ): AxiosPromise<GetBindingsResponse> {
      return ProcessingApiFp(configuration).apiProcessingGetBindingsPost(getBindingsRequest, options)(axios, basePath)
    },
    /**
     * [AntiForgeryToken]
     * @summary Получение категорий каталога
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetCategoriesGet(options?: any): AxiosPromise<Array<ServiceCategoryInfo>> {
      return ProcessingApiFp(configuration).apiProcessingGetCategoriesGet(options)(axios, basePath)
    },
    /**
     * [Authorize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetLoansListGet(options?: any): AxiosPromise<GetLoansListResponse> {
      return ProcessingApiFp(configuration).apiProcessingGetLoansListGet(options)(axios, basePath)
    },
    /**
     * [AntiForgeryToken]
     * @param {string} [mdOrder]
     * @param {string} [refNumber]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetOperationDetailsGet(
      mdOrder?: string,
      refNumber?: string,
      options?: any
    ): AxiosPromise<OperationDetails> {
      return ProcessingApiFp(configuration).apiProcessingGetOperationDetailsGet(
        mdOrder,
        refNumber,
        options
      )(axios, basePath)
    },
    /**
     * [AntiForgeryToken]
     * @summary Получение информации по привязанному платежному инструменту – продукту Банка
     * @param {string} [bindingId] Уникальный идентификатор ПИ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetProductBindingWithBalanceGet(bindingId?: string, options?: any): AxiosPromise<GetBindingResponse> {
      return ProcessingApiFp(configuration).apiProcessingGetProductBindingWithBalanceGet(bindingId, options)(
        axios,
        basePath
      )
    },
    /**
     * [AntiForgeryToken]
     * @summary Получение ТСП по id
     * @param {string} [serviceId] Идентификатор ТСП
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetServiceByIdGet(serviceId?: string, options?: any): AxiosPromise<ServiceInfo> {
      return ProcessingApiFp(configuration).apiProcessingGetServiceByIdGet(serviceId, options)(axios, basePath)
    },
    /**
     * [AntiForgeryToken]
     * @summary Получение каталога ТСП
     * @param {string} [category] Название категории, для которой запрашивается каталог
     * @param {string} [region] Регион для которого запрашивается каталог. MOW(Москва по умолчанию)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetServicesGet(category?: string, region?: string, options?: any): AxiosPromise<Array<ServiceInfo>> {
      return ProcessingApiFp(configuration).apiProcessingGetServicesGet(category, region, options)(axios, basePath)
    },
    /**
     * [AntiForgeryToken]
     * @param {GetTransferTermsRequest} [getTransferTermsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingGetTransferTermsPost(
      getTransferTermsRequest?: GetTransferTermsRequest,
      options?: any
    ): AxiosPromise<GetTransferTermsResponse> {
      return ProcessingApiFp(configuration).apiProcessingGetTransferTermsPost(getTransferTermsRequest, options)(
        axios,
        basePath
      )
    },
    /**
     *
     * @summary Идентификация пользователя по 3ds 2.0.
     * @param {ThreeDsProceedDto} [threeDsProceedDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingProceed3ds2Post(
      threeDsProceedDto?: ThreeDsProceedDto,
      options?: any
    ): AxiosPromise<CreateBindingResult> {
      return ProcessingApiFp(configuration).apiProcessingProceed3ds2Post(threeDsProceedDto, options)(axios, basePath)
    },
    /**
     *
     * @param {string} [query]
     * @param {string} [region]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingSearchServicesGet(
      query?: string,
      region?: string,
      options?: any
    ): AxiosPromise<Array<SearchServiceResult>> {
      return ProcessingApiFp(configuration).apiProcessingSearchServicesGet(query, region, options)(axios, basePath)
    },
    /**
     *
     * @param {SendReceiptRequest} [sendReceiptRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingSendReceiptPost(
      sendReceiptRequest?: SendReceiptRequest,
      options?: any
    ): AxiosPromise<SendReceiptResult> {
      return ProcessingApiFp(configuration).apiProcessingSendReceiptPost(sendReceiptRequest, options)(axios, basePath)
    },
    /**
     * [AntiForgeryToken]
     * @param {TransferRequest} [transferRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferPost(transferRequest?: TransferRequest, options?: any): AxiosPromise<OperationResponse> {
      return ProcessingApiFp(configuration).apiProcessingTransferPost(transferRequest, options)(axios, basePath)
    },
  }
}

/**
 * ProcessingApi - object-oriented interface
 * @export
 * @class ProcessingApi
 * @extends {BaseAPI}
 */
export class ProcessingApi extends BaseAPI {
  /**
   * [Authorize, AntiForgeryToken]
   * @summary Создание нового ПИ
   * @param {CreateBindingRequest} [createBindingRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingCreateBindingPost(createBindingRequest?: CreateBindingRequest, options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingCreateBindingPost(createBindingRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   *
   * @summary Завершить операцию с 3DSecure2
   * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingFinish3ds2Post(finish3DsRequest?: Finish3DsRequest, options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingFinish3ds2Post(finish3DsRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   *
   * @summary Завершить операцию с 3DSecure
   * @param {Finish3DsRequest} [finish3DsRequest] Запрос на завершение операции с 3DSecure
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingFinish3dsPost(finish3DsRequest?: Finish3DsRequest, options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingFinish3dsPost(finish3DsRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   * [Authorize]
   * @param {string} [number]
   * @param {string} [dateFrom]
   * @param {string} [dateTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingGetAccountOperationsPost(number?: string, dateFrom?: string, dateTo?: string, options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingGetAccountOperationsPost(
      number,
      dateFrom,
      dateTo,
      options
    )(this.axios, this.basePath)
  }

  /**
   * [Authorize, AntiForgeryToken]
   * @param {GetBindingsRequest} [getBindingsRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingGetBindingsPost(getBindingsRequest?: GetBindingsRequest, options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingGetBindingsPost(getBindingsRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   * [AntiForgeryToken]
   * @summary Получение категорий каталога
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingGetCategoriesGet(options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingGetCategoriesGet(options)(this.axios, this.basePath)
  }

  /**
   * [Authorize]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingGetLoansListGet(options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingGetLoansListGet(options)(this.axios, this.basePath)
  }

  /**
   * [AntiForgeryToken]
   * @param {string} [mdOrder]
   * @param {string} [refNumber]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingGetOperationDetailsGet(mdOrder?: string, refNumber?: string, options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingGetOperationDetailsGet(
      mdOrder,
      refNumber,
      options
    )(this.axios, this.basePath)
  }

  /**
   * [AntiForgeryToken]
   * @summary Получение информации по привязанному платежному инструменту – продукту Банка
   * @param {string} [bindingId] Уникальный идентификатор ПИ
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingGetProductBindingWithBalanceGet(bindingId?: string, options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingGetProductBindingWithBalanceGet(bindingId, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   * [AntiForgeryToken]
   * @summary Получение ТСП по id
   * @param {string} [serviceId] Идентификатор ТСП
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingGetServiceByIdGet(serviceId?: string, options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingGetServiceByIdGet(serviceId, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   * [AntiForgeryToken]
   * @summary Получение каталога ТСП
   * @param {string} [category] Название категории, для которой запрашивается каталог
   * @param {string} [region] Регион для которого запрашивается каталог. MOW(Москва по умолчанию)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingGetServicesGet(category?: string, region?: string, options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingGetServicesGet(
      category,
      region,
      options
    )(this.axios, this.basePath)
  }

  /**
   * [AntiForgeryToken]
   * @param {GetTransferTermsRequest} [getTransferTermsRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingGetTransferTermsPost(getTransferTermsRequest?: GetTransferTermsRequest, options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingGetTransferTermsPost(getTransferTermsRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   *
   * @summary Идентификация пользователя по 3ds 2.0.
   * @param {ThreeDsProceedDto} [threeDsProceedDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingProceed3ds2Post(threeDsProceedDto?: ThreeDsProceedDto, options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingProceed3ds2Post(threeDsProceedDto, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   *
   * @param {string} [query]
   * @param {string} [region]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingSearchServicesGet(query?: string, region?: string, options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingSearchServicesGet(
      query,
      region,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @param {SendReceiptRequest} [sendReceiptRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingSendReceiptPost(sendReceiptRequest?: SendReceiptRequest, options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingSendReceiptPost(sendReceiptRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   * [AntiForgeryToken]
   * @param {TransferRequest} [transferRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessingApi
   */
  public apiProcessingTransferPost(transferRequest?: TransferRequest, options?: any) {
    return ProcessingApiFp(this.configuration).apiProcessingTransferPost(transferRequest, options)(
      this.axios,
      this.basePath
    )
  }
}

/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * [Authorize]
     * @param {string} [phrase]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProfileHashitGet(phrase?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/profile/hashit`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (phrase !== undefined) {
        localVarQueryParameter['phrase'] = phrase
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [Authorize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProfileMtsClientInfoGet(options: any = {}): RequestArgs {
      const localVarPath = `/api/profile/mtsClientInfo`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * [Authorize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProfileMtsProfileGet(options: any = {}): RequestArgs {
      const localVarPath = `/api/profile/mtsProfile`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function (configuration?: Configuration) {
  return {
    /**
     * [Authorize]
     * @param {string} [phrase]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProfileHashitGet(
      phrase?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<HashItResponce> {
      const localVarAxiosArgs = ProfileApiAxiosParamCreator(configuration).apiProfileHashitGet(phrase, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [Authorize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProfileMtsClientInfoGet(
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MtsClientInfo> {
      const localVarAxiosArgs = ProfileApiAxiosParamCreator(configuration).apiProfileMtsClientInfoGet(options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * [Authorize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProfileMtsProfileGet(
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string }> {
      const localVarAxiosArgs = ProfileApiAxiosParamCreator(configuration).apiProfileMtsProfileGet(options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     * [Authorize]
     * @param {string} [phrase]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProfileHashitGet(phrase?: string, options?: any): AxiosPromise<HashItResponce> {
      return ProfileApiFp(configuration).apiProfileHashitGet(phrase, options)(axios, basePath)
    },
    /**
     * [Authorize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProfileMtsClientInfoGet(options?: any): AxiosPromise<MtsClientInfo> {
      return ProfileApiFp(configuration).apiProfileMtsClientInfoGet(options)(axios, basePath)
    },
    /**
     * [Authorize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProfileMtsProfileGet(options?: any): AxiosPromise<{ [key: string]: string }> {
      return ProfileApiFp(configuration).apiProfileMtsProfileGet(options)(axios, basePath)
    },
  }
}

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
  /**
   * [Authorize]
   * @param {string} [phrase]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public apiProfileHashitGet(phrase?: string, options?: any) {
    return ProfileApiFp(this.configuration).apiProfileHashitGet(phrase, options)(this.axios, this.basePath)
  }

  /**
   * [Authorize]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public apiProfileMtsClientInfoGet(options?: any) {
    return ProfileApiFp(this.configuration).apiProfileMtsClientInfoGet(options)(this.axios, this.basePath)
  }

  /**
   * [Authorize]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public apiProfileMtsProfileGet(options?: any) {
    return ProfileApiFp(this.configuration).apiProfileMtsProfileGet(options)(this.axios, this.basePath)
  }
}

/**
 * PromoApi - axios parameter creator
 * @export
 */
export const PromoApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPromoGet(options: any = {}): RequestArgs {
      const localVarPath = `/api/promo`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PromoApi - functional programming interface
 * @export
 */
export const PromoApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPromoGet(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromotionsResponse> {
      const localVarAxiosArgs = PromoApiAxiosParamCreator(configuration).apiPromoGet(options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * PromoApi - factory interface
 * @export
 */
export const PromoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiPromoGet(options?: any): AxiosPromise<PromotionsResponse> {
      return PromoApiFp(configuration).apiPromoGet(options)(axios, basePath)
    },
  }
}

/**
 * PromoApi - object-oriented interface
 * @export
 * @class PromoApi
 * @extends {BaseAPI}
 */
export class PromoApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromoApi
   */
  public apiPromoGet(options?: any) {
    return PromoApiFp(this.configuration).apiPromoGet(options)(this.axios, this.basePath)
  }
}

/**
 * RegionApi - axios parameter creator
 * @export
 */
export const RegionApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRegionGet(options: any = {}): RequestArgs {
      const localVarPath = `/api/region`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * RegionApi - functional programming interface
 * @export
 */
export const RegionApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRegionGet(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Region>> {
      const localVarAxiosArgs = RegionApiAxiosParamCreator(configuration).apiRegionGet(options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * RegionApi - factory interface
 * @export
 */
export const RegionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRegionGet(options?: any): AxiosPromise<Array<Region>> {
      return RegionApiFp(configuration).apiRegionGet(options)(axios, basePath)
    },
  }
}

/**
 * RegionApi - object-oriented interface
 * @export
 * @class RegionApi
 * @extends {BaseAPI}
 */
export class RegionApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegionApi
   */
  public apiRegionGet(options?: any) {
    return RegionApiFp(this.configuration).apiRegionGet(options)(this.axios, this.basePath)
  }
}

/**
 * ThreeDs2Api - axios parameter creator
 * @export
 */
export const ThreeDs2ApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} mdOrder
     * @param {string} threeDSMethodData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _3ds2NotifyPost(mdOrder: string, threeDSMethodData: string, options: any = {}): RequestArgs {
      // verify required parameter 'mdOrder' is not null or undefined
      if (mdOrder === null || mdOrder === undefined) {
        throw new RequiredError(
          'mdOrder',
          'Required parameter mdOrder was null or undefined when calling _3ds2NotifyPost.'
        )
      }
      // verify required parameter 'threeDSMethodData' is not null or undefined
      if (threeDSMethodData === null || threeDSMethodData === undefined) {
        throw new RequiredError(
          'threeDSMethodData',
          'Required parameter threeDSMethodData was null or undefined when calling _3ds2NotifyPost.'
        )
      }
      const localVarPath = `/3ds2/Notify`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new FormData()

      if (mdOrder !== undefined) {
        localVarQueryParameter['mdOrder'] = mdOrder
      }

      if (threeDSMethodData !== undefined) {
        localVarFormParams.append('threeDSMethodData', threeDSMethodData as any)
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      localVarRequestOptions.data = localVarFormParams

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {ThreeDsProceedBindModel} [threeDsProceedBindModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _3ds2ProceedBindPost(threeDsProceedBindModel?: ThreeDsProceedBindModel, options: any = {}): RequestArgs {
      const localVarPath = `/3ds2/Proceed/Bind`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof threeDsProceedBindModel !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(threeDsProceedBindModel !== undefined ? threeDsProceedBindModel : {})
        : threeDsProceedBindModel || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {ThreeDsProceedPayModel} [threeDsProceedPayModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _3ds2ProceedPayPost(threeDsProceedPayModel?: ThreeDsProceedPayModel, options: any = {}): RequestArgs {
      const localVarPath = `/3ds2/Proceed/Pay`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof threeDsProceedPayModel !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(threeDsProceedPayModel !== undefined ? threeDsProceedPayModel : {})
        : threeDsProceedPayModel || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} mdOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _3ds2StatusMdOrderGet(mdOrder: string, options: any = {}): RequestArgs {
      // verify required parameter 'mdOrder' is not null or undefined
      if (mdOrder === null || mdOrder === undefined) {
        throw new RequiredError(
          'mdOrder',
          'Required parameter mdOrder was null or undefined when calling _3ds2StatusMdOrderGet.'
        )
      }
      const localVarPath = `/3ds2/Status/{mdOrder}`.replace(`{${'mdOrder'}}`, encodeURIComponent(String(mdOrder)))
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ThreeDs2Api - functional programming interface
 * @export
 */
export const ThreeDs2ApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} mdOrder
     * @param {string} threeDSMethodData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _3ds2NotifyPost(
      mdOrder: string,
      threeDSMethodData: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = ThreeDs2ApiAxiosParamCreator(configuration)._3ds2NotifyPost(
        mdOrder,
        threeDSMethodData,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {ThreeDsProceedBindModel} [threeDsProceedBindModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _3ds2ProceedBindPost(
      threeDsProceedBindModel?: ThreeDsProceedBindModel,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = ThreeDs2ApiAxiosParamCreator(configuration)._3ds2ProceedBindPost(
        threeDsProceedBindModel,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {ThreeDsProceedPayModel} [threeDsProceedPayModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _3ds2ProceedPayPost(
      threeDsProceedPayModel?: ThreeDsProceedPayModel,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = ThreeDs2ApiAxiosParamCreator(configuration)._3ds2ProceedPayPost(
        threeDsProceedPayModel,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {string} mdOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _3ds2StatusMdOrderGet(
      mdOrder: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
      const localVarAxiosArgs = ThreeDs2ApiAxiosParamCreator(configuration)._3ds2StatusMdOrderGet(mdOrder, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ThreeDs2Api - factory interface
 * @export
 */
export const ThreeDs2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     *
     * @param {string} mdOrder
     * @param {string} threeDSMethodData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _3ds2NotifyPost(mdOrder: string, threeDSMethodData: string, options?: any): AxiosPromise<void> {
      return ThreeDs2ApiFp(configuration)._3ds2NotifyPost(mdOrder, threeDSMethodData, options)(axios, basePath)
    },
    /**
     *
     * @param {ThreeDsProceedBindModel} [threeDsProceedBindModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _3ds2ProceedBindPost(threeDsProceedBindModel?: ThreeDsProceedBindModel, options?: any): AxiosPromise<void> {
      return ThreeDs2ApiFp(configuration)._3ds2ProceedBindPost(threeDsProceedBindModel, options)(axios, basePath)
    },
    /**
     *
     * @param {ThreeDsProceedPayModel} [threeDsProceedPayModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _3ds2ProceedPayPost(threeDsProceedPayModel?: ThreeDsProceedPayModel, options?: any): AxiosPromise<void> {
      return ThreeDs2ApiFp(configuration)._3ds2ProceedPayPost(threeDsProceedPayModel, options)(axios, basePath)
    },
    /**
     *
     * @param {string} mdOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _3ds2StatusMdOrderGet(mdOrder: string, options?: any): AxiosPromise<void> {
      return ThreeDs2ApiFp(configuration)._3ds2StatusMdOrderGet(mdOrder, options)(axios, basePath)
    },
  }
}

/**
 * ThreeDs2Api - object-oriented interface
 * @export
 * @class ThreeDs2Api
 * @extends {BaseAPI}
 */
export class ThreeDs2Api extends BaseAPI {
  /**
   *
   * @param {string} mdOrder
   * @param {string} threeDSMethodData
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThreeDs2Api
   */
  public _3ds2NotifyPost(mdOrder: string, threeDSMethodData: string, options?: any) {
    return ThreeDs2ApiFp(this.configuration)._3ds2NotifyPost(
      mdOrder,
      threeDSMethodData,
      options
    )(this.axios, this.basePath)
  }

  /**
   *
   * @param {ThreeDsProceedBindModel} [threeDsProceedBindModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThreeDs2Api
   */
  public _3ds2ProceedBindPost(threeDsProceedBindModel?: ThreeDsProceedBindModel, options?: any) {
    return ThreeDs2ApiFp(this.configuration)._3ds2ProceedBindPost(threeDsProceedBindModel, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   *
   * @param {ThreeDsProceedPayModel} [threeDsProceedPayModel]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThreeDs2Api
   */
  public _3ds2ProceedPayPost(threeDsProceedPayModel?: ThreeDsProceedPayModel, options?: any) {
    return ThreeDs2ApiFp(this.configuration)._3ds2ProceedPayPost(threeDsProceedPayModel, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   *
   * @param {string} mdOrder
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThreeDs2Api
   */
  public _3ds2StatusMdOrderGet(mdOrder: string, options?: any) {
    return ThreeDs2ApiFp(this.configuration)._3ds2StatusMdOrderGet(mdOrder, options)(this.axios, this.basePath)
  }
}

/**
 * TransfersApi - axios parameter creator
 * @export
 */
export const TransfersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingSuggestBicGet(query?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/suggest/bic`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (query !== undefined) {
        localVarQueryParameter['query'] = query
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingSuggestPartyGet(query?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/suggest/party`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (query !== undefined) {
        localVarQueryParameter['query'] = query
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CheckTransferRequest} [checkTransferRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferCheckPost(checkTransferRequest?: CheckTransferRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/transfer/check`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof checkTransferRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(checkTransferRequest !== undefined ? checkTransferRequest : {})
        : checkTransferRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {ExTransferRequest} [exTransferRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferDoextPost(exTransferRequest?: ExTransferRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/transfer/doext`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof exTransferRequest !== 'string' || localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(exTransferRequest !== undefined ? exTransferRequest : {})
        : exTransferRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {GetTransferTypeRequest} [getTransferTypeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferGettypePost(getTransferTypeRequest?: GetTransferTypeRequest, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/transfer/gettype`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json-patch+json'

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }
      const needsSerialization =
        typeof getTransferTypeRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(getTransferTypeRequest !== undefined ? getTransferTypeRequest : {})
        : getTransferTypeRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [transferId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferStatusGet(transferId?: string, options: any = {}): RequestArgs {
      const localVarPath = `/api/processing/transfer/status`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (transferId !== undefined) {
        localVarQueryParameter['transferId'] = transferId
      }

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * TransfersApi - functional programming interface
 * @export
 */
export const TransfersApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingSuggestBicGet(
      query?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SuggestBankInfo>> {
      const localVarAxiosArgs = TransfersApiAxiosParamCreator(configuration).apiProcessingSuggestBicGet(query, options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {string} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingSuggestPartyGet(
      query?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PartyInfo>> {
      const localVarAxiosArgs = TransfersApiAxiosParamCreator(configuration).apiProcessingSuggestPartyGet(
        query,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {CheckTransferRequest} [checkTransferRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferCheckPost(
      checkTransferRequest?: CheckTransferRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckTransferResponse> {
      const localVarAxiosArgs = TransfersApiAxiosParamCreator(configuration).apiProcessingTransferCheckPost(
        checkTransferRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {ExTransferRequest} [exTransferRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferDoextPost(
      exTransferRequest?: ExTransferRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExTransferResponse> {
      const localVarAxiosArgs = TransfersApiAxiosParamCreator(configuration).apiProcessingTransferDoextPost(
        exTransferRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {GetTransferTypeRequest} [getTransferTypeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferGettypePost(
      getTransferTypeRequest?: GetTransferTypeRequest,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTransferTypeResult> {
      const localVarAxiosArgs = TransfersApiAxiosParamCreator(configuration).apiProcessingTransferGettypePost(
        getTransferTypeRequest,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     *
     * @param {string} [transferId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferStatusGet(
      transferId?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferStateResponse> {
      const localVarAxiosArgs = TransfersApiAxiosParamCreator(configuration).apiProcessingTransferStatusGet(
        transferId,
        options
      )
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * TransfersApi - factory interface
 * @export
 */
export const TransfersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     *
     * @param {string} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingSuggestBicGet(query?: string, options?: any): AxiosPromise<Array<SuggestBankInfo>> {
      return TransfersApiFp(configuration).apiProcessingSuggestBicGet(query, options)(axios, basePath)
    },
    /**
     *
     * @param {string} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingSuggestPartyGet(query?: string, options?: any): AxiosPromise<Array<PartyInfo>> {
      return TransfersApiFp(configuration).apiProcessingSuggestPartyGet(query, options)(axios, basePath)
    },
    /**
     *
     * @param {CheckTransferRequest} [checkTransferRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferCheckPost(
      checkTransferRequest?: CheckTransferRequest,
      options?: any
    ): AxiosPromise<CheckTransferResponse> {
      return TransfersApiFp(configuration).apiProcessingTransferCheckPost(checkTransferRequest, options)(
        axios,
        basePath
      )
    },
    /**
     *
     * @param {ExTransferRequest} [exTransferRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferDoextPost(
      exTransferRequest?: ExTransferRequest,
      options?: any
    ): AxiosPromise<ExTransferResponse> {
      return TransfersApiFp(configuration).apiProcessingTransferDoextPost(exTransferRequest, options)(axios, basePath)
    },
    /**
     *
     * @param {GetTransferTypeRequest} [getTransferTypeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferGettypePost(
      getTransferTypeRequest?: GetTransferTypeRequest,
      options?: any
    ): AxiosPromise<GetTransferTypeResult> {
      return TransfersApiFp(configuration).apiProcessingTransferGettypePost(getTransferTypeRequest, options)(
        axios,
        basePath
      )
    },
    /**
     *
     * @param {string} [transferId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcessingTransferStatusGet(transferId?: string, options?: any): AxiosPromise<TransferStateResponse> {
      return TransfersApiFp(configuration).apiProcessingTransferStatusGet(transferId, options)(axios, basePath)
    },
  }
}

/**
 * TransfersApi - object-oriented interface
 * @export
 * @class TransfersApi
 * @extends {BaseAPI}
 */
export class TransfersApi extends BaseAPI {
  /**
   *
   * @param {string} [query]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransfersApi
   */
  public apiProcessingSuggestBicGet(query?: string, options?: any) {
    return TransfersApiFp(this.configuration).apiProcessingSuggestBicGet(query, options)(this.axios, this.basePath)
  }

  /**
   *
   * @param {string} [query]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransfersApi
   */
  public apiProcessingSuggestPartyGet(query?: string, options?: any) {
    return TransfersApiFp(this.configuration).apiProcessingSuggestPartyGet(query, options)(this.axios, this.basePath)
  }

  /**
   *
   * @param {CheckTransferRequest} [checkTransferRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransfersApi
   */
  public apiProcessingTransferCheckPost(checkTransferRequest?: CheckTransferRequest, options?: any) {
    return TransfersApiFp(this.configuration).apiProcessingTransferCheckPost(checkTransferRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   *
   * @param {ExTransferRequest} [exTransferRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransfersApi
   */
  public apiProcessingTransferDoextPost(exTransferRequest?: ExTransferRequest, options?: any) {
    return TransfersApiFp(this.configuration).apiProcessingTransferDoextPost(exTransferRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   *
   * @param {GetTransferTypeRequest} [getTransferTypeRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransfersApi
   */
  public apiProcessingTransferGettypePost(getTransferTypeRequest?: GetTransferTypeRequest, options?: any) {
    return TransfersApiFp(this.configuration).apiProcessingTransferGettypePost(getTransferTypeRequest, options)(
      this.axios,
      this.basePath
    )
  }

  /**
   *
   * @param {string} [transferId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransfersApi
   */
  public apiProcessingTransferStatusGet(transferId?: string, options?: any) {
    return TransfersApiFp(this.configuration).apiProcessingTransferStatusGet(transferId, options)(
      this.axios,
      this.basePath
    )
  }
}
